module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "toctitle"
  }, [_c('i', [_vm._v("Addresses of Music Publishers")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_vm._v("A bracketed number (e.g., "), _c('b', [_vm._v("[1])")]), _vm._v(" following the name of a publisher corresponds to that of its American agent, distributor, or parent company (see preceding listing, “American Agents, Distributors, or Parent Companies of Music Publishers”). "), _c('b', [_vm._v("Bold print")]), _vm._v(" has been added to help the reader find items in the alphabetical sequence. In cases where no information about a publisher was found, the last known address is given. Readers are encouraged to bear in mind that addresses frequently change and that these can often be checked on the worldwide web or through the Music Publishers Association of the United States ("), _c('a', {
    attrs: {
      "href": "http://www.mpa.org",
      "target": "_blank"
    }
  }, [_vm._v("www.mpa.org")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Academia Brasileira de Música")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua da Lapa"), _c('br'), _vm._v("120/12° andar"), _c('br'), _vm._v("20021-180 Rio de Janeiro, Brazil"), _c('br'), _vm._v("Tel/Fax: (21) 2292-5845"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.abmusica.org.br",
      "target": "_blank"
    }
  }, [_vm._v("www.abmusica.org.br")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Acanthus")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach"), _c('br'), _vm._v("4522 Rüttenen SO, Switzerland"), _c('br'), _vm._v("Tel: (41) 32-637-06-30"), _c('br'), _vm._v("Fax: (41) 32-637-06-31"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.acanthus-music.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.acanthus-music.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni Giuseppe "), _c('b', [_vm._v("Accardi")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rotterdam, The Netherlands"), _c('br'), _vm._v("c/o Musica Repartita"), _c('br'), _vm._v("Goedestraat 133"), _c('br'), _vm._v("3572 RS Utrecht"), _c('br'), _vm._v("The Netherlands"), _c('br'), _vm._v("Tel: (31) 30-718465")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Accent")]), _vm._v(" Music "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Adeva")]), _vm._v(" Musik ("), _c('i', [_vm._v("see")]), _vm._v(" Bärenreiter)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Aenear")]), _vm._v(" Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Toronto, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Africanus")]), _vm._v(" Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3126 Shenandoah Avenue"), _c('br'), _vm._v("St. Louis, MO 63104"), _c('br'), _vm._v("Tel: (314) 773-8769")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ahn & Simrock")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hamburg, Germany"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.theaterverlagmuenchen.de/as_allg.php",
      "target": "_blank"
    }
  }, [_vm._v("www.theaterverlagmuenchen.de/as_allg.php")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Akkord")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Barackos út 28/a"), _c('br'), _vm._v("1224 Budapest, Hungary"), _c('br'), _vm._v("Fax: (36) 1-207-4767"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.akkordmusic.hu",
      "target": "_blank"
    }
  }, [_vm._v("www.akkordmusic.hu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Alacran")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("695 Wrelton Drive"), _c('br'), _vm._v("San Diego, CA 92109")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Albersen")]), _vm._v(" Muziek")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Valeriusstraat 12"), _c('br'), _vm._v("2517 HR Den Haag"), _c('br'), _vm._v("The Netherlands"), _c('br'), _vm._v("Tel: (31) 70-345-6000"), _c('br'), _vm._v("Fax: (31) 70-345-71-10"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.albersen.nl",
      "target": "_blank"
    }
  }, [_vm._v("www.albersen.nl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. "), _c('b', [_vm._v("Albert")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" E. B. Marks)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Allans")]), _vm._v(" Music Australia "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("ALMA")]), _vm._v(" (Association for Latin-American")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Music and Art)"), _c('br'), _vm._v("10985 West Broward Blvd."), _c('br'), _vm._v("Plantation, FL 33324"), _c('br'), _vm._v("Tel: (888) 275-2562"), _c('br'), _vm._v("Fax: (954) 915-9144"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.alma-usa.com",
      "target": "_blank"
    }
  }, [_vm._v("www.alma-usa.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Alpeg")]), _vm._v(" Editions "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Alsbach [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Amadeus [8, 10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hermannstrasse 7"), _c('br'), _vm._v("8400 Winterthur, Switzerland"), _c('br'), _vm._v("Tel: (41) 52-233-28-66"), _c('br'), _vm._v("Fax: (41) 52-233-54-01"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.amadeusmusic.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.amadeusmusic.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Composers Alliance:")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Composers Facsimile Edition"), _c('br'), _vm._v("802 W. 190th Street 1st Floor"), _c('br'), _vm._v("New York, NY 10040"), _c('br'), _vm._v("Tel: (212) 925-0458"), _c('br'), _vm._v("Fax: (212) 925-6798"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.composers.com",
      "target": "_blank"
    }
  }, [_vm._v("www.composers.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Composers Forum")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("332 Minnesota Street, Suite East 145"), _c('br'), _vm._v("St. Paul, MN 55101-1300"), _c('br'), _vm._v("Tel: (651) 228-1407"), _c('br'), _vm._v("Fax: (651) 291-7978"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.composersforum.org",
      "target": "_blank"
    }
  }, [_vm._v("www.composersforum.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Institute of Musicology")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(includes The Corpus of Early Music Keyboard Music)"), _c('br'), _vm._v("c/o Tempo Music Publications"), _c('br'), _vm._v("3773 W. 95th Street"), _c('br'), _vm._v("Leawood, KS 66206"), _c('br'), _vm._v("Tel: (913) 381-5088 or (800) 733-5066"), _c('br'), _vm._v("Fax: (913) 381-5081"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.tempomusic.com/aim",
      "target": "_blank"
    }
  }, [_vm._v("www.tempomusic.com/aim")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Music Center")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" New Music USA)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Music Editions")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("263 East 7th Street"), _c('br'), _vm._v("New York, NY 10009-6049"), _c('br'), _vm._v("Fax: (212) 420-9393"), _c('br'), _c('i', [_vm._v("Archive:")]), _c('br'), _vm._v("Northwestern University Library"), _c('br'), _vm._v("1970 Campus Drive"), _c('br'), _vm._v("Evanston, Illinois 60208-2300"), _c('br'), _vm._v("Tel: (847) 491-7658"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.library.northwestern.edu/libraries-collections/evanston-campus/music-library/collections/special-collections/american-music",
      "target": "_blank"
    }
  }, [_vm._v("www.library.northwestern.edu/libraries-collections/evanston-campus/music-library/collections/special-collections/american-music")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Gli "), _c('b', [_vm._v("Amici della Musica da Camera")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Bocca di Leone 25"), _c('br'), _vm._v("Rome, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Amphion")]), _vm._v(" Éditions Musicales "), _c('b', [_vm._v("[10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("AMS")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Brooklyn Navy Yard"), _c('br'), _vm._v("63 Flushing Avenue, Unit #221"), _c('br'), _vm._v("Brooklyn, NY 11205-1073"), _c('br'), _vm._v("Fax: (718) 875-3800"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.amspressinc.com",
      "target": "_blank"
    }
  }, [_vm._v("www.amspressinc.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Amsco")]), _vm._v(" School Publishing "), _c('b', [_vm._v("[13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("315 Hudson Street"), _c('br'), _vm._v("New York, NY 10013-1085")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 969-8398 or (212) 886-6500")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 886-6515"), _c('br'), _c('a', {
    attrs: {
      "href": "http://amscopub.com",
      "target": "_blank"
    }
  }, [_vm._v("amscopub.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Johann "), _c('b', [_vm._v("André")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Frankfurterstrasse 28")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("63065 Offenbach, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 69-813539")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 69-815339"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musik-andre.de",
      "target": "_blank"
    }
  }, [_vm._v("www.musik-andre.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Andromeda")]), _vm._v(" Editrice "), _c('b', [_vm._v("[10]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("64042 Colledara (Te), Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 861-699014")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 861-699000"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.organisti.it/andromeda.htm",
      "target": "_blank"
    }
  }, [_vm._v("www.organisti.it/andromeda.htm")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Anglican [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("A-R")]), _vm._v(" Editions "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("8551 Research Way, Suite 180"), _c('br'), _vm._v("Middleton, WI 5356")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (608) 836-9000 or (800) 736-0070")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (608) 831-8200"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.areditions.com",
      "target": "_blank"
    }
  }, [_vm._v("www.areditions.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("A-Ram")]), _vm._v(" Edition")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Moscow, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arbeitsgemeinschaft der Eigenverleger")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lasserstraße 6")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5020 Salzburg, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (66) 2-78-86-84")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Groupe "), _c('b', [_vm._v("Archambault")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("500 Est, Rue Ste-Catherine Montreal"), _c('br'), _vm._v("Quebec, H2L 2C6 Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (514) 849-6201")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (514) 849-1481")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ariadne")]), _vm._v(" Verlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Geibelgasse 14")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1150 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-8953255")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-8953244-20"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ariadne-verlag.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ariadne-verlag.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Collecion "), _c('b', [_vm._v("Arion [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Armelin")]), _vm._v(" Musica")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via dei Soncin, 42")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("35122 Padova, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 49-8724-928")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 49-8736-524"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.armelin.it",
      "target": "_blank"
    }
  }, [_vm._v("www.armelin.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arno Press [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arno Volk Verlag")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arrow")]), _vm._v(" Music Press "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ars Viva")]), _vm._v(" Verlag "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Weihergarten 5")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("55116 Mainz, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 6131-2460")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 6131-246-211")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arsis")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Empire Publishing Service")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 1344"), _c('br'), _vm._v("Studio City, CA 91614")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (818) 784-8918")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (818) 990-2477"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.arsispress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.arsispress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Art Publication of St. Louis [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Artia [2, 8, 12]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Prague, Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ascherberg, Hopwood & Crew,")]), _vm._v(" Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Music Publishers"), _c('br'), _vm._v("c/o Chappell International Music"), _c('br'), _vm._v("Publ. Group Ltd."), _c('br'), _vm._v("50 New Bond Street"), _c('br'), _vm._v("London W1A 2BR, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edwin "), _c('b', [_vm._v("Ashdown [6, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ashley")]), _vm._v(" Dealers Service "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Hermann "), _c('b', [_vm._v("Assmann")]), _vm._v(" Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Franz-Werfel-Strasse 3660431"), _c('br'), _vm._v("Frankfurt 50, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49-69) 532431/526231")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Associated Board of the Royal School of Music [14, 15]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("24 Portland Place"), _c('br'), _vm._v("London W1B 1LU"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-7636-5400")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-7637-0234"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.abrsm.org",
      "target": "_blank"
    }
  }, [_vm._v("www.abrsm.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Associated Music Publishers [10, 13, 16, 17]")]), _vm._v(" (part of Music Sales Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("New York, NY")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Astoria")]), _vm._v(" Verlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Weihergarten 5")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("55116 Mainz, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 6131-246-889")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 6131-246-250"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.astoria-verlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.astoria-verlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Augener [5]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Australian Music Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box N690"), _c('br'), _vm._v("Grosvenor Place"), _c('br'), _vm._v("Sydney NSW 1220, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (61) 2-9247-4677")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (61) 2-9241-2873"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.amcoz.com.au/amc",
      "target": "_blank"
    }
  }, [_vm._v("www.amcoz.com.au/amc")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Authors Agency of the Polish Music Publishers")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("ul. Hipteczna 2,"), _c('br'), _vm._v("00-950 Warsaw, Poland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Autographus Musicus")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Årdalavägen158")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("12432 Bandhagen, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Axelrod [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musica "), _c('b', [_vm._v("Baltica [14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Kr. Barona 39-1"), _c('br'), _vm._v("Riga 1011, Latvia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (371) 67-275575")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (371) 67-272755"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musicabaltica.com",
      "target": "_blank"
    }
  }, [_vm._v("www.musicabaltica.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Banks")]), _vm._v(" Music "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("The Granary, Wath Court"), _c('br'), _vm._v("Hovingham, York YO62 4NN"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 1653-628545")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 1653-627214"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.banksmusicpublications.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.banksmusicpublications.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bardic")]), _vm._v(" Edition "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("6 Fairfax Crescent"), _c('br'), _vm._v("Aylesbury, Bucks HP20 2ES"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) (1296) 428609")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("U.S. Tel: (914) 816-1137")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) (1296) 581185"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bardic-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bardic-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bärenreiter")]), _vm._v(" Verlag "), _c('b', [_vm._v("[4, 6, 8, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(works of Schoenberg dist. in U.S. by Belmont)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Heinrich-Schütz-Allee 35-37"), _c('br'), _vm._v("34131 Kassel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 561-3105-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 561-3105-240"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.baerenreiter.com/nc/en/",
      "target": "_blank"
    }
  }, [_vm._v("www.baerenreiter.com/nc/en/")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editio "), _c('b', [_vm._v("Bärenreiter Praha")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("namestri Jiriho z Podebrad 112/19"), _c('br'), _vm._v("130 00 Prague 3, Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (420) 274-001-911")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (420) 222-220-829"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ebp.cz",
      "target": "_blank"
    }
  }, [_vm._v("www.ebp.cz")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Barry [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bartók Records")]), _vm._v(" and Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 399"), _c('br'), _vm._v("Homosassa, FL 34487")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (352) 382-2015")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (352) 382-0341"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bartokrecords.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bartokrecords.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("M. P. "), _c('b', [_vm._v("Belaieff [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Mainz, Germany"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.belaieff-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.belaieff-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Belmont")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1221 Bienveneda Avenue"), _c('br'), _vm._v("Pacific Palisades, CA 90272")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (310) 454-1867")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (310) 573-1925"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schoenbergmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schoenbergmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Belwin-Mills [1, 6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Berandol")]), _vm._v(" Music Ltd. (Canada) "), _c('b', [_vm._v("[6, 11, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 45059")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("81 Lakeshore Road E."), _c('br'), _vm._v("Mississauga, ON L5G 2X4, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (877) 356-1002 or (905) 278-6338")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (905) 278-9409"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.berandolmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.berandolmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("Bèrben [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Redipuglia 65")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("60122 Ancona, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 71-204428")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 71-57414"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.berben.it",
      "target": "_blank"
    }
  }, [_vm._v("www.berben.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edição "), _c('b', [_vm._v("Bevilacqua [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Biblioteca Central [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sección de Música"), _c('br'), _vm._v("Barcelona, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Biedermann [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Gerald "), _c('b', [_vm._v("Billaudot,")]), _vm._v(" Editeur/Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Billaudot "), _c('b', [_vm._v("[6, 13, 15, 17]")]), _c('br'), _vm._v("14, Rue de l'Échiquier"), _c('br'), _vm._v("75010 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-47-70-14-46")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-45-23-22-54"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.billaudot.com",
      "target": "_blank"
    }
  }, [_vm._v("www.billaudot.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Black Cat")]), _vm._v(" Productions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10808 124th Street"), _c('br'), _vm._v("Edmonton, AB, T5M 0H4, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 661-3613")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (780) 447-5337")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("BMI Canada,")]), _vm._v(" Ltd. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Boccaccini e Spada [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Arezzo 17")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("00040 Pavona di Albano Laziale"), _c('br'), _vm._v("(Rome), Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 6-9310217 or (39) 6-9310561")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 6-9311903"), _c('br'), _vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:bsmusica@tiscalinet.it"
    }
  }, [_vm._v("bsmusica@tiscalinet.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Fred "), _c('b', [_vm._v("Bock [10, 13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 570567"), _c('br'), _vm._v("Tarzana, CA 91357")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (818) 996-6181")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (818) 996-2043"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fredbock.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fredbock.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Boelke-Bomart")]), _vm._v(" Music Publications ("), _c('i', [_vm._v("see")]), _vm._v(" Jerona Music Corp.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bolamar")]), _vm._v(" Ediciones Musicales")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Azor, 5 (Molino de la Hoz)"), _c('br'), _vm._v("28232 Las Rozas (Madrid), Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 916303643"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bolamar.net",
      "target": "_blank"
    }
  }, [_vm._v("www.bolamar.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bomart")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Boelke-Bomart)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bongiovanni")]), _vm._v(" Francesco Edizioni Musicali")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Ugo Bassi, 31/F"), _c('br'), _vm._v("40121 Bologna, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 51-22-57-22")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 51-22-61-28")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Joseph "), _c('b', [_vm._v("Boonin")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Jerona Music Corp.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bosse")]), _vm._v(" Edition "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 417")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("84 Regensburg 2, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Boston")]), _vm._v(" Music "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bosworth")]), _vm._v(" & Co. "), _c('b', [_vm._v("[3, 6, 10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bote & Bock [6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bourne")]), _vm._v(" Company "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5 West 37th Street, 6th Floor"), _c('br'), _vm._v("New York, NY 10018")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 391-4300")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 391-4306"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bournemusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bournemusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bowdoin College")]), _vm._v(" Music Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bowdoin College"), _c('br'), _vm._v("Brunswick, ME 04011"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.library.bowdoin.edu/arch/archives/bcmpg.shtml",
      "target": "_blank"
    }
  }, [_vm._v("www.library.bowdoin.edu/arch/archives/bcmpg.shtml")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("Boxwood")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("183 Ocean View Blvd."), _c('br'), _vm._v("Pacific Grove, CA 93950")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (408) 375-9110")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bradley")]), _vm._v(" Publications "), _c('b', [_vm._v("[1]")]), _vm._v(" (formerly through CPP/Belwin Music)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Branden")]), _vm._v(" Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Div. of Branden Books")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 812094"), _c('br'), _vm._v("Wellesley, MA 02482"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.brandenbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.brandenbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bratti [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Brazilian Music")]), _vm._v(" Enterprises "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Breitkopf & Härtel [6, 8, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Walkmühlstraße 52")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("65195 Wiesbaden, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 611-45008-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 611-45008 59-61"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.breitkopf.com",
      "target": "_blank"
    }
  }, [_vm._v("www.breitkopf.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("British Library")]), _vm._v(" Publishing Office")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("96 Euston Road"), _c('br'), _vm._v("London NW1 2DB"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-7412-7704"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.publishing.bl.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.publishing.bl.uk")]), _c('br'), _c('b', [_vm._v("distributed in the U.S. & Canada by")]), _c('br'), _vm._v("University of Chicago Press"), _c('br'), _vm._v("1427 E. 60th Street"), _c('br'), _vm._v("Chicago, IL 60637")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (773) 702-7248")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (773) 702-9756"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.press.uchicago.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.press.uchicago.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Broadbent & Dunn [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("66 Nursery Lane"), _c('br'), _vm._v("Dover, Kent, CT16 3EX"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 1304-825604"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.broadbent-dunn.com",
      "target": "_blank"
    }
  }, [_vm._v("www.broadbent-dunn.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Broadcast Music,")]), _vm._v(" Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10 Music Square East"), _c('br'), _vm._v("Nashville, TN 37203-4399")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (615) 401-2000"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bmi.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bmi.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Broekmans & Van Poppel [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Van Baerlestraat 92-94"), _c('br'), _vm._v("1071 BB Amsterdam"), _c('br'), _vm._v("The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (31) 20-679-65-75 or 20-659-72-70")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (31) 20-664-67-59"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.broekmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.broekmans.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Dr. J. "), _c('b', [_vm._v("Butz")]), _vm._v(" Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 30 09 54")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("53189 Bonn, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 228-946-949-24"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.butz-verlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.butz-verlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cambria")]), _vm._v(" Publishing "), _c('b', [_vm._v("[17, 18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cambridge University Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("32 Avenue of the Americas"), _c('br'), _vm._v("New York, NY 10013")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 337-5000 or (845) 353-7500"), _c('br'), _vm._v("(customer service)"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cambridge.org",
      "target": "_blank"
    }
  }, [_vm._v("www.cambridge.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Canadian Music Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20 St. Joseph Street"), _c('br'), _vm._v("Toronto, Ontario M4Y 1J9, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (416) 961-6601")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (416) 961-7198"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musiccentre.ca",
      "target": "_blank"
    }
  }, [_vm._v("www.musiccentre.ca")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cantext")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("19 Laval Drive")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Winnipeg R3T 2XB, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (204) 275-1598")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Canyon")]), _vm._v(" Press "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Carisch,")]), _vm._v(" S.P.A. "), _c('b', [_vm._v("[2, 6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Canova 55")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20020 Lainate, Italy"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.carisch.com",
      "target": "_blank"
    }
  }, [_vm._v("www.carisch.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Carlanita")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[10, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 698, Cathedral Station"), _c('br'), _vm._v("New York, NY 10025")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("Carrara")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via A. da Calepio, 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("24125 Bergamo, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 35-243618")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 35-270298"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edizionicarrara.it",
      "target": "_blank"
    }
  }, [_vm._v("www.edizionicarrara.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Carus")]), _vm._v("-Verlag "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sielminger Str. 51")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("70771 LE-Echterdingen, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 711-797-330-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 711-797-330-29"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.carus-verlag.com",
      "target": "_blank"
    }
  }, [_vm._v("www.carus-verlag.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Valentim de "), _c('b', [_vm._v("Carvalho")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Estrada de Paço de Arcos, 26"), _c('br'), _vm._v("2770-129 Paço de Arcos, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (351) 214-401-000")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (351) 214-401-095"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.valentim.pt",
      "target": "_blank"
    }
  }, [_vm._v("www.valentim.pt")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Casa Amarilla")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Santiago, Chile")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (56) 2-698-3483"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.casamarilla.cl",
      "target": "_blank"
    }
  }, [_vm._v("www.casamarilla.cl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Casa "), _c('b', [_vm._v("Iriberri [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Casia")]), _vm._v(" Publishing "), _c('b', [_vm._v("[7]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Catamount")]), _vm._v(" Facsimile Editions ("), _c('i', [_vm._v("see")]), _vm._v(" American Composers Alliance)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Caveat")]), _vm._v(" Music Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o E.C. Kerby Itd."), _c('br'), _vm._v("198 Davenport Road"), _c('br'), _vm._v("Toronto M5R 1J2, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (416) 922-9934")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("CeBeDeM")]), _vm._v(" (Centre Belge de Documentation Musicale)"), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Avenue du port 86c bte 214")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1000 Brussels, Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (32) 2-230-94-30")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (32) 2-230-94-37"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cebedem.be",
      "target": "_blank"
    }
  }, [_vm._v("www.cebedem.be")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Century")]), _vm._v(" Music Publishing Co. ("), _c('i', [_vm._v("see")]), _vm._v(" Ashley Dealers)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Le "), _c('b', [_vm._v("Chant du Monde [6, 7, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("31-33 Rue Vandrezanne"), _c('br'), _vm._v("75013 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-53-80-12-30")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-53-80-12-18"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chantdumonde.com",
      "target": "_blank"
    }
  }, [_vm._v("www.chantdumonde.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chappell")]), _vm._v(" & Co. "), _c('b', [_vm._v("[1, 10, 13]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Warner/Chappel Music)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cherry Lane")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10 Midland Avenue"), _c('br'), _vm._v("Port Chester, NY 10573")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (914) 935-5200")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (914) 937-0614"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cherrylane.mseek.net",
      "target": "_blank"
    }
  }, [_vm._v("www.cherrylane.mseek.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chesky Hudebni Fond")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Český rozhlas"), _c('br'), _vm._v("Římská 13")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("120 99 Prague, Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (420) 221-553-361")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (420) 221-553-355"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hudebnifond.cz",
      "target": "_blank"
    }
  }, [_vm._v("www.hudebnifond.cz")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. W. "), _c('b', [_vm._v("Chester [16]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Chester Music below)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chester")]), _vm._v(" Music "), _c('b', [_vm._v("[10, 13, 17]")]), _vm._v(" (now part of Music Sales Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("14-15 Berners Street"), _c('br'), _vm._v("London W1T 3LJ"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-7612-7400")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-7612-7545"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chesternovello.com",
      "target": "_blank"
    }
  }, [_vm._v("www.chesternovello.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chiarato")]), _vm._v(" & Cia. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("São Paulo, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Choudens [16, 17]")]), _vm._v(" (now part of Music Sales Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chromattica [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chronos")]), _vm._v(" Music (absorbed by Cormorant Press; "), _c('i', [_vm._v("see")]), _vm._v(" Cormorant Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("John "), _c('b', [_vm._v("Church")]), _vm._v(" Company "), _c('b', [_vm._v("[18]")]), _vm._v(" (no longer in business)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Andrea "), _c('b', [_vm._v("Coen-Zanibon [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Franco "), _c('b', [_vm._v("Colombo [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Columbia Music Company [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.comusco.com",
      "target": "_blank"
    }
  }, [_vm._v("www.comusco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Columbia University Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("61 West 62nd Street")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("New York, NY 10023")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.cc.columbia.edu/cu/cup",
      "target": "_blank"
    }
  }, [_vm._v("www.cc.columbia.edu/cu/cup")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 459-0600 or (800) 343-4499")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(Perseus Dist.)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 459-3678 (sales)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.cup.columbia.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.cup.columbia.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Composer/Performer Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("330 University Avenue"), _c('br'), _vm._v("Davis, CA 95616")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Composers Library")]), _vm._v(" Editions "), _c('b', [_vm._v("[7, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Composers")]), _vm._v(" Press ("), _c('i', [_vm._v("see")]), _vm._v(" Seesaw Music Corp.) "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Compozitor")]), _vm._v(" Publishing House")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bolshaya Morskaya St., 45")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("190000 St. Petersburg, Russia"), _c('br'), _vm._v("Tel/Fax: (7) 812-314-50-54"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.compozitor.spb.ru/eng",
      "target": "_blank"
    }
  }, [_vm._v("www.compozitor.spb.ru/eng")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Concordia")]), _vm._v(" Publishing House "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3558 S. Jefferson St."), _c('br'), _vm._v("St. Louis, MO 63118")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (314) 268-1000 or (800) 325-3040")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (800) 490-9889"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cph.org",
      "target": "_blank"
    }
  }, [_vm._v("www.cph.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Conners")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("503 Tahoe Street"), _c('br'), _vm._v("Natchitoches, LA 71457-5718")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (318) 357-0924"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.music-usa.org/conners",
      "target": "_blank"
    }
  }, [_vm._v("www.music-usa.org/conners")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Consolidated")]), _vm._v(" Music Publishers (part of Music Sales Corp.)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("257 Park Avenue South, 20th Floor"), _c('br'), _vm._v("New York, NY 10010")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 254-2100")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 254-2013"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schirmer.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schirmer.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("Consort")]), _vm._v(" Press "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1273 S. Rice Road, #8"), _c('br'), _vm._v("Ojai, CA 93023")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (805) 646-4779"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.consortpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.consortpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Continuo")]), _vm._v(" Music Press "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Copa [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cormorant Press [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cornetto")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hummelgasse 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("70378 Stuttgart, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 711-9561396")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 711-9561-397"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cornetto-music.de",
      "target": "_blank"
    }
  }, [_vm._v("www.cornetto-music.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. B. "), _c('b', [_vm._v("Cramer")]), _vm._v(" & Co., Ltd. "), _c('b', [_vm._v("[2, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cranz [3, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Creazioni Artistiche Musicali")]), _vm._v(" (C.A.M.)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Cola di Rienzo, 152")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("00192 Rome, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) (6) 6840791")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) (6) 6874046")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Crescendo")]), _vm._v(" Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (888) 602-8466"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.crescendopublishing.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.crescendopublishing.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Crystal Spring")]), _vm._v(" Music Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("250 Ohua Avenue, 10E"), _c('br'), _vm._v("Honolulu, HI 96815")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (808) 923-6859")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Culver Crest")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 4484"), _c('br'), _vm._v("Culver City, CA 90231-4484"), _c('br'), _vm._v("Tel/Fax: (310) 838-4465"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.culvercrest.com/Culver_Crest_Publications",
      "target": "_blank"
    }
  }, [_vm._v("www.culvercrest.com/Culver_Crest_Publications")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("Curci [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Galleria del Corso, 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20122 Milano, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 2-76-03-61")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 2-76-01-45-04"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edizionicurci.it",
      "target": "_blank"
    }
  }, [_vm._v("www.edizionicurci.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Currency Press")]), _vm._v(" Pty Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('i', [_vm._v("Street address:")]), _vm._v(" 164 James Street"), _c('br'), _vm._v("Redfern NSW 2016, Australia"), _c('br'), _vm._v("M"), _c('i', [_vm._v("ailing address:")]), _vm._v(" P.O. Box 2287"), _c('br'), _vm._v("Strawberry Hills 2012 NSW Australia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (61) (2) 9319-5877")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (61) (2) 9319-3649"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.currency.com.au",
      "target": "_blank"
    }
  }, [_vm._v("www.currency.com.au")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. "), _c('b', [_vm._v("Curwen")]), _vm._v(" & Son (England) "), _c('b', [_vm._v("[6, 10, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Czech State Music [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Da Capo")]), _vm._v(" Press "), _c('b', [_vm._v("[17]")]), _vm._v(" (part of Perseus Books Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("44 Farnsworth Street, 3rd Floor"), _c('br'), _vm._v("Boston, MA 02210")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (617) 252-5200 or"), _c('br'), _vm._v("(800) 343-4499 (orders)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (800) 351-5073 (orders)"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.perseusbooksgroup.com/dacapo",
      "target": "_blank"
    }
  }, [_vm._v("www.perseusbooksgroup.com/dacapo")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Dantalian,")]), _vm._v(" Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("11 Pembroke Street"), _c('br'), _vm._v("Newton, MA 02458"), _c('br'), _vm._v("Tel/Fax: (617) 244-7230"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.dantalian.com",
      "target": "_blank"
    }
  }, [_vm._v("www.dantalian.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("De Ring [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("de Santis")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Viale Mazzini 6")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("00195 Rome, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Deep Listening")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 1956"), _c('br'), _vm._v("Kingston, NY 12402")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (914) 338-5984"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.deeplistening.org",
      "target": "_blank"
    }
  }, [_vm._v("www.deeplistening.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Georges "), _c('b', [_vm._v("Delrieu [5, 6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("11, Rue de Paris"), _c('br'), _vm._v("06000 Nice, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 4-93-88-61-96"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.georgesdelrieu.com",
      "target": "_blank"
    }
  }, [_vm._v("www.georgesdelrieu.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Derry")]), _vm._v(" Music Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("221 Main Street, Suite 440"), _c('br'), _vm._v("San Francisco, CA 94105")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (415) 537-9640")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Desforges [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Le Havre, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Deutscher Verlag für Musik")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Leipzig, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("DGR")]), _vm._v(" Publishers (name changed to Seda Publications; "), _c('i', [_vm._v("see")]), _vm._v(" Seda Publications)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Oliver "), _c('b', [_vm._v("Ditson")]), _vm._v(" Company "), _c('b', [_vm._v("[15]")]), _vm._v(" (a subsdiary of TP)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.presser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.presser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Les Éditions "), _c('b', [_vm._v("Doberman-Yppan [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2220, Chemin du Fleuve"), _c('br'), _vm._v("Saint-Romuald, QC"), _c('br'), _vm._v("G6W 1Y4 Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (418) 834-8384")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (418) 834-3522"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.dobermaneditions.com",
      "target": "_blank"
    }
  }, [_vm._v("www.dobermaneditions.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Ludwig "), _c('b', [_vm._v("Doblinger [6, 8, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Dohr [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sindorfer Straße 19"), _c('br'), _vm._v("50127 Bergheim, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 2271-70-72-05/06")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 2271-70-72-07"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.dohr.de",
      "target": "_blank"
    }
  }, [_vm._v("www.dohr.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Donemus")]), _vm._v(" Publishing "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Amsterdam, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: 6-4520-5176"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.donemus.nl",
      "target": "_blank"
    }
  }, [_vm._v("www.donemus.nl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Donna [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Düsseldorf, German")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Dotesio")]), _vm._v(" (Spain) ("), _c('i', [_vm._v("see")]), _vm._v(" Union Musical Española)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Dover")]), _vm._v(" Publications "), _c('b', [_vm._v("[1, 8, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("31 East Second Street")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Mineola, NY 11501-3582")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 223-3130 or (516) 294-7000")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (516) 742-6953"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.doverpublications.com",
      "target": "_blank"
    }
  }, [_vm._v("www.doverpublications.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Dreililien")]), _vm._v(" Verlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Richard Birnbach"), _c('br'), _vm._v("Aubinger Strasse 9")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("82166 Gräfelfing, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49-89) 875450")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("L. K. "), _c('b', [_vm._v("Drew")]), _vm._v(" Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("303 Orton Road"), _c('br'), _vm._v("Yellow Springs, OH 45387")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (937) 767-9383")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Duma")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("557 Barron Avenue"), _c('br'), _vm._v("Woodbridge, NJ 07095")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (732) 636-5406")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (732) 636-5220"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.dumamusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.dumamusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Durand Costallat [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Durand [2, 6, 8, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.durand-salabert-eschig.com",
      "target": "_blank"
    }
  }, [_vm._v("www.durand-salabert-eschig.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Eastman School of Music")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("26 Gibbs Street"), _c('br'), _vm._v("Rochester, NY 14604")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (585) 274-1000"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.esm.rochester.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.esm.rochester.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ediciones Musicales")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Campanario No. 315"), _c('br'), _vm._v("Havana, Cuba")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editio Musica Budapest (EMB) [2, 6, 13, 15; 21,")]), _vm._v(" New Liszt Edition only]")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 322")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1370 Budapest, Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (36) 1-2361-104")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (36) 1-2361-101"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.emb.hu",
      "target": "_blank"
    }
  }, [_vm._v("www.emb.hu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Chroma")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 816"), _c('br'), _vm._v("Duncan, BC V9L 3Y2"), _c('br'), _vm._v("Canada")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Gravis")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Grabbeallee 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("13156 Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 30-61-69-81-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 30-61-69-81-21"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editiongravis.de",
      "target": "_blank"
    }
  }, [_vm._v("www.editiongravis.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Modern [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Nordstern")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Spitzwegstr. 17")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("70192 Stuttgart, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 711-8179106"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edno.de",
      "target": "_blank"
    }
  }, [_vm._v("www.edno.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Pan [11]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Edition Russe de Musique [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Tympanon")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Karl-Heinz Schickhaus"), _c('br'), _vm._v("Markt 52"), _c('br'), _vm._v("4271 St. Oswald b. Fr., Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 79-45-81-10")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Les Éditions "), _c('b', [_vm._v("Bleu Blanc Rouge")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Hansen House)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Éditions d'Etat pour la Littérature et l'Art [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bucharest, Rumania")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions de la "), _c('b', [_vm._v("Sirène Musicale [18]")]), _vm._v(" Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Éditions du Centre de Musique Baroque de Versailles")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hôtel des Menus Plaisirs"), _c('br'), _vm._v("22, Avenue de Paris"), _c('br'), _vm._v("78003 Versailles Cedex, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-39-20-78-10")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-39-20-78-01"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cmbv.fr/Recherche-UMR/Activites-scientifiques/Editions-musicologiques",
      "target": "_blank"
    }
  }, [_vm._v("http://www.cmbv.fr/Recherche-UMR/Activites-scientifiques/Editions-musicologiques")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Musicales de la "), _c('b', [_vm._v("Schola Cantorum")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("et de la Procure Générale de Musique &"), _c('br'), _vm._v("Labatiaz ("), _c('i', [_vm._v("see")]), _vm._v(" Labatiaz)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Musicales "), _c('b', [_vm._v("des Marais")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Editions Jobert)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Musicales "), _c('b', [_vm._v("Transatlantiques [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Ray "), _c('b', [_vm._v("Ventura [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions "), _c('b', [_vm._v("Rideau Rouge [10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Romanos [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3 Michael Koutsofta str.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 56202")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3305 Limassol, Cyprus")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (357) 92-46-024")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (357) 92-41-362")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editions 75")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("75, Rue de la Roquette"), _c('br'), _vm._v("75011 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-43-48-90-57")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-43-48-85-74"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editions75.com",
      "target": "_blank"
    }
  }, [_vm._v("www.editions75.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editorial Argentina")]), _vm._v(" de Música "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editorial Cooperativa Interamericana de Compositores [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial de Música "), _c('b', [_vm._v("Boileau [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/ Provença, 287")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("08037 Barcelona, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 93-487-74-56 or"), _c('br'), _vm._v("(34) 93-215-53-34")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 93-215-53-34"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.boileau-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.boileau-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial de "), _c('b', [_vm._v("Música Española Contemporánea")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Alcalá, 70")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("28009 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34-91) 5770752")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) (91) 5757645")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial "), _c('b', [_vm._v("Politonia [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editura de Stat "), _c('b', [_vm._v("Pentru")]), _vm._v(" Literatura si Arta")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("("), _c('i', [_vm._v("see")]), _vm._v(" Editura Eminescu)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editura "), _c('b', [_vm._v("Eminescu")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Piata Presei Libere nr.1, corp C, et. 3,"), _c('br'), _vm._v("cam. 360")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sector 1, Bucurest, Romania"), _c('br'), _vm._v("Tel/Fax: (40) 31-805-8938"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edituraeminescu.ro",
      "target": "_blank"
    }
  }, [_vm._v("www.edituraeminescu.ro")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("Curci")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Galleria del Corso, 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20122 Milano, Italy"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edizionicurci.it",
      "target": "_blank"
    }
  }, [_vm._v("www.edizionicurci.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Elkan & Schildknecht")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Emil Carelius AB"), _c('br'), _vm._v("Kungsholmsgatan 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("112 27 Stockholm, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (46) 8-6515421")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Elkan-Vogel [15]")]), _vm._v(" (a subsidiary of T. Presser)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.presser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.presser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("William "), _c('b', [_vm._v("Elkin")]), _vm._v(" Music Services [In U.S., "), _c('i', [_vm._v("see")]), _vm._v(" "), _c('b', [_vm._v("6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Elkin Music International"), _c('br'), _vm._v("Station Road Industrial Estate Salhouse"), _c('br'), _vm._v("Norwich NR13 6NS, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44-1603) 721302")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44-1603) 721801")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Engström & Södring")]), _vm._v(" (Denmark) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Enoch")]), _vm._v(" & Cie "), _c('b', [_vm._v("[6, 13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Eres")]), _vm._v(" Edition")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Horst Schubert"), _c('br'), _vm._v("Hauptstraße 35")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("28865 Lilienthal, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 04298-1676")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 04298-5312"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.eres-musik.de",
      "target": "_blank"
    }
  }, [_vm._v("www.eres-musik.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Erviti")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("San Martin, 28 bajo"), _c('br'), _vm._v("20.005 San Sebastian, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 943-30-04-93")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 943-20-03-43")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Max "), _c('b', [_vm._v("Eschig [2, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.durand-salabert-eschig.com",
      "target": "_blank"
    }
  }, [_vm._v("www.durand-salabert-eschig.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Euganea")]), _vm._v(" Editoriale Comunicazioni")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Cernaia, 84")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("35142 Padova, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 049657493")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Eulenburg")]), _vm._v(" (Schott Music) "), _c('b', [_vm._v("[6, 8, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("European American")]), _vm._v(" Music Distributors Corp. and European American Retail Music "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Excelsior")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Faber")]), _vm._v(" Music "), _c('b', [_vm._v("[1, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fairfield,")]), _vm._v(" Ltd. ("), _c('i', [_vm._v("see")]), _vm._v(" Novello)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Manuel de "), _c('b', [_vm._v("Falla")]), _vm._v(" Ediciones "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("S.L. C/ Breton de los Herreros, 55-Bajo F"), _c('br'), _vm._v("28003 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34-91) 441-77-43")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34-91) 442-60-96"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.manueldefallaediciones.es",
      "target": "_blank"
    }
  }, [_vm._v("www.manueldefallaediciones.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fallen Leaf Press")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" J. W. Pepper)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 10034"), _c('br'), _vm._v("Berkeley, CA 94709"), _c('br'), _vm._v("Tel/Fax: (510) 848-7805"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fallenleaf.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fallenleaf.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musik "), _c('b', [_vm._v("Fabrik [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("18, Rue Marthe Aureau"), _c('br'), _vm._v("77400 Lagny-sur-Marne, France"), _c('br'), _vm._v("Tel/Fax: (33) 1-73-58-50-59"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.classicalmusicnow.com",
      "target": "_blank"
    }
  }, [_vm._v("www.classicalmusicnow.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Fazer [6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("FEMA")]), _vm._v(" Music Publications "), _c('b', [_vm._v("[")]), _vm._v("out of business"), _c('b', [_vm._v("]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fentone")]), _vm._v(" Music (England) "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Finnish Information Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lauttasaarentie 1")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("00200 Helsinki, Finland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (358) 9-68101313")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (358) 9-682-0070"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fimic.fi",
      "target": "_blank"
    }
  }, [_vm._v("www.fimic.fi")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. "), _c('b', [_vm._v("Fisher")]), _vm._v(" & Bro. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("FJH")]), _vm._v(" Music Company "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2525 Davie Road, Suite 360"), _c('br'), _vm._v("Fort Lauderdale, FL 33317-7424")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 262-8744 or (954) 382-6061")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (954) 382-3073"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fjhmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fjhmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("FLP")]), _vm._v(" Music Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 60806"), _c('br'), _vm._v("Oklahoma City, OK 73146"), _c('br'), _vm._v("(Does business by mail only.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("La "), _c('b', [_vm._v("Flûte de Pan")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("59, Rue de Rome (Piano scores)"), _c('br'), _vm._v("75008 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-42-93-47-82"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.laflutedepan.com",
      "target": "_blank"
    }
  }, [_vm._v("www.laflutedepan.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Foetisch")]), _vm._v(" Frères, S.A. "), _c('b', [_vm._v("[7, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lausanne, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Charles "), _c('b', [_vm._v("Foley,")]), _vm._v(" Inc. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Fondazione "), _c('b', [_vm._v("Carminignani Rossini [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Pesaro, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Fondazione "), _c('b', [_vm._v("Eugenio Bravi [18]")]), _vm._v(" Milan, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Forberg [14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("A. "), _c('b', [_vm._v("Forlivesi [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Stelloni 3/A"), _c('br'), _vm._v("40010 Sala Bolognese BO, Italy"), _c('br'), _vm._v("Tel: (39) 51-6814142/98")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 51-6814672"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.forlivesi.it",
      "target": "_blank"
    }
  }, [_vm._v("www.forlivesi.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Arnaldo "), _c('b', [_vm._v("Forni,")]), _vm._v(" Editore")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Gramsci 164"), _c('br'), _vm._v("40010 Sala Bologna, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39-51) 95-41-42 / 95-41-98")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39-51) 95-46-72"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fornieditore.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fornieditore.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Forsyth Brothers [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("126 Deansgate"), _c('br'), _vm._v("Manchester M3 2GR"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 161-956-2052")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 161-834-0630"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.forsyths.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.forsyths.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Sam "), _c('b', [_vm._v("Fox")]), _vm._v(" Music Sales "), _c('b', [_vm._v("[15]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Warner/Chappell)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Frangipani")]), _vm._v(" Press "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Frank")]), _vm._v(" Music Corporation "), _c('b', [_vm._v("[10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fredonia")]), _vm._v(" Press Discs")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3947 Fredonia Drive"), _c('br'), _vm._v("Los Angeles, CA 90068"), _c('br'), _vm._v("Tel: (323) 851-3043")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("H. "), _c('b', [_vm._v("Freeman")]), _vm._v(" & Company "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Frog Peak")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Box 1052"), _c('br'), _vm._v("Lebanon, NH 03766"), _c('br'), _vm._v("Tel/Fax: (603) 643-9037"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.frogpeak.org",
      "target": "_blank"
    }
  }, [_vm._v("www.frogpeak.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fromont [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Theodore "), _c('b', [_vm._v("Front")]), _vm._v(" Music Literature")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("6122 Cohasset Street"), _c('br'), _vm._v("Van Nuys, CA 91406-2989")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (818) 994-1902")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (818) 994-0419"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.tfront.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tfront.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fujihara")]), _vm._v(" Music Company "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Furore")]), _vm._v(" Verlag "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Naumberger Straße 40")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("34127 Kassel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 561-500-493-11")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 561-500-493-20"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.furore-verlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.furore-verlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Adolph "), _c('b', [_vm._v("Fürstner [13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Galaxy")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[5, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Galliard,")]), _vm._v(" Ltd. (England) "), _c('b', [_vm._v("[5]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Garland")]), _vm._v(" Publishing "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("270 Madison Avenue #4"), _c('br'), _vm._v("New York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (917) 315-7100")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Carl "), _c('b', [_vm._v("Gehrmans")]), _vm._v(" Musikförlag "), _c('b', [_vm._v("[2, 6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 42026")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("126 12 Stockholm, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (46) 8-6100-600"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.gehrmans.se",
      "target": "_blank"
    }
  }, [_vm._v("www.gehrmans.se")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("General Music Publishing")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Boston Music Company)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("General Words and Music [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Daniel "), _c('b', [_vm._v("Gerard")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5 Plain Avenue"), _c('br'), _vm._v("New Rochelle, NY"), _c('br'), _vm._v("Tel: (914) 235-2525")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musikverlag Hans "), _c('b', [_vm._v("Gerig [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Girard [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Naples, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Glocken")]), _vm._v(" Verlag "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("12-14 Mortimer Street"), _c('br'), _vm._v("London WIT 3JJ"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Goldberg")]), _vm._v(" Ediçôes Musicais")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua S. Vicente 360 ap A"), _c('br'), _vm._v("Porto Alegre (Rio Grande do Sul)"), _c('br'), _vm._v("Brazil"), _c('br'), _vm._v("Tel: (51) 3388-87-46")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Greenwood Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("World Library Publications"), _c('br'), _vm._v("2145 Central Parkway"), _c('br'), _vm._v("Cincinnati, OH 45214")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Gregg International")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("White Swan Ho"), _c('br'), _vm._v("Godstone, Surrey RH9 8LW"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44-1883) 744214")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44-1883) 744024")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Henri "), _c('b', [_vm._v("Gregh")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("129, rue Montmartre"), _c('br'), _vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Grupo "), _c('b', [_vm._v("Renovación [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("GSP Music")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("230 Townsend Street"), _c('br'), _vm._v("San Francisco, CA 94107-1720")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (415) 896-1144"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.gspguitar.com",
      "target": "_blank"
    }
  }, [_vm._v("www.gspguitar.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Gulbenkian Foundation")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Parque de Sta. Gertrudes à Avda. de"), _c('br'), _vm._v("Berna")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lisbon, Portugal"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Wolfgang G. "), _c('b', [_vm._v("Haas")]), _vm._v("-Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 90 07 48"), _c('br'), _vm._v("Köln, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 2203-98-88-3-50")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 2203-98-88-3-50"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.haas-koeln.de",
      "target": "_blank"
    }
  }, [_vm._v("www.haas-koeln.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("G. K. "), _c('b', [_vm._v("Hall")]), _vm._v(" & Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Simon & Schuster "), _c('b', [_vm._v("[13]")]), _c('br'), _vm._v("200 Old Tappan Road"), _c('br'), _vm._v("Old Tappan, NJ 07675-7095")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 257-5157")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (800) 558-4676"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.simonandschuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonandschuster.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hamelle [13, 15, 17]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Leduc)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hansen House")]), _vm._v(" Music "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1820 West Avenue"), _c('br'), _vm._v("Miami Beach, FL 33139")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (305) 532-5461")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (305) 672-8729"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hansenhousemusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hansenhousemusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Wilhelm "), _c('b', [_vm._v("Hansen [6, 10, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bornholmsgade 1A"), _c('br'), _vm._v("1266 Copenhagan K, Denmark"), _c('br'), _vm._v("Tel: (45) 33-11-78-88")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (45) 33-14-81-78"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ewh.dk",
      "target": "_blank"
    }
  }, [_vm._v("www.ewh.dk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hänssler")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" American Institute of Musicology) "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hargail")]), _vm._v(" Music Press "), _c('b', [_vm._v("[11]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Harmonia Uitgave [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Roeltjesweg 23-25"), _c('br'), _vm._v("Hilversum, Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Frederick "), _c('b', [_vm._v("Harris")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(Distributed in the U.S. by FJH Music Company. "), _c('i', [_vm._v("See")]), _vm._v(" FJH.) Suite 882")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("60 Industrial Parkway"), _c('br'), _vm._v("Cheektowaga, NY 14227")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 387-4013")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (416) 408-1542"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.frederickharrismusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.frederickharrismusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Harvard University Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("79 Garden Street"), _c('br'), _vm._v("Cambridge, MA 02138-1499")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 448-2242 or (617) 495-2600")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (617) 495-5898"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hup.harvard.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.hup.harvard.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Heinrichshofen")]), _vm._v(" Edition "), _c('b', [_vm._v("[16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Liebigstraße 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("26389 Wilhelmshaven, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 4421-9267-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 4421-9267-99"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.heinrichshofen.de",
      "target": "_blank"
    }
  }, [_vm._v("www.heinrichshofen.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Helicon")]), _vm._v(" Music ("), _c('i', [_vm._v("see")]), _vm._v(" Schott)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Helios")]), _vm._v(" Music Edition ("), _c('i', [_vm._v("see")]), _vm._v(" Plymouth Music)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("G. "), _c('b', [_vm._v("Henle")]), _vm._v(" USA. Inc. "), _c('b', [_vm._v("[6, 8, 10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Forstenrieder Allee 122")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("81476 Munchen, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 89-759-82-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 89-759-82-40"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.henleusa.com",
      "target": "_blank"
    }
  }, [_vm._v("www.henleusa.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Henmar")]), _vm._v(" Press (USA) "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions "), _c('b', [_vm._v("Henn")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5-7 Rue de l'Ancien-Port"), _c('br'), _vm._v("1201 Geneva, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (41) 22-738-91-10")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (41) 22-738-91-16")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("HBS "), _c('b', [_vm._v("Hepomuk")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Entfelderstrasse 39")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5000 Aarau, Switzerland"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hbs-nepomuk.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.hbs-nepomuk.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hermes Beard")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("7121 Viewpoint Road"), _c('br'), _vm._v("Aptos, CA 95003")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Heugel [13, 15, 17]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Leduc)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Heuwekemeijer [13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.editionheuwekemeijer.nl",
      "target": "_blank"
    }
  }, [_vm._v("www.editionheuwekemeijer.nl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hidden Oaks")]), _vm._v(" Music Company")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 47696"), _c('br'), _vm._v("San Antonio, TX 78284-9765")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (210) 590-1689"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.efabregas.com",
      "target": "_blank"
    }
  }, [_vm._v("www.efabregas.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Highgate")]), _vm._v(" Press "), _c('b', [_vm._v("[5]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hildegard")]), _vm._v(" Publishing Company "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 18860"), _c('br'), _vm._v("Mount Airy, PA 19010")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (610) 667-8634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (215) 359-0654"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hildegard.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hildegard.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hinrichsen")]), _vm._v(" Edition (England) "), _c('b', [_vm._v("[14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hinshaw")]), _vm._v(" Music "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(Hinshaw no longer publishes piano literature)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Friedrich "), _c('b', [_vm._v("Hofmeister")]), _vm._v(" (Germany) "), _c('b', [_vm._v("[6, 17,")]), _vm._v(" "), _c('i', [_vm._v("see also:")]), _vm._v(" William Elkin]")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hope")]), _vm._v(" Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("380 South Main Place"), _c('br'), _vm._v("Carol Stream, IL 60188"), _c('br'), _vm._v("Tel: (800) 323-1049 or (630) 665-3200")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (630) 665-2552"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hopepublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hopepublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hudební Matice")]), _vm._v(" (Czech Republic) "), _c('b', [_vm._v("[18]")]), _vm._v(" (no longer in business)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hug [6, 11, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Case Postale 6455")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1002 Lausanne, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (41) 21-310-48-10")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (41) 21-310-48-19"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musikhug.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.musikhug.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hyperion")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("45 Riverside Avenue"), _c('br'), _vm._v("Westport, CT 06880"), _c('br'), _vm._v("*Division of Disney Book Publishing"), _c('br'), _vm._v("114 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 343-9204 or (212) 633-4400")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 633-4811")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ichthys")]), _vm._v(" Verlag GmbH "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("IMI")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Israel Music Institute)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Imma")]), _vm._v(" Publishing Company")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1600 East Avenue, #1115"), _c('br'), _vm._v("Rochester, NY 14610"), _c('br'), _vm._v("Tel: (585) 413-1651"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.martaandriasova.webs.com",
      "target": "_blank"
    }
  }, [_vm._v("www.martaandriasova.webs.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Impero")]), _vm._v("-Verlag "), _c('b', [_vm._v("[13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Imprimus")]), _vm._v(" Music ("), _c('i', [_vm._v("see")]), _vm._v(" Sikesdi Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Indiana University")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("William and Gayle Cook Music Library")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Simon Music Library & Recital Center")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("200 South Jordan Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bloomington, IN 47405")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (812) 855-2970")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (812) 855-3843")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.music.indiana.edu/muslib",
      "target": "_blank"
    }
  }, [_vm._v("www.music.indiana.edu/muslib")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Instituto de Extensión Musicale")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Calle Compañia"), _c('br'), _vm._v("1274 Santiago, Chile")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("International Music Company [10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5 W. 37th Street"), _c('br'), _vm._v("New York, NY 10018")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 391-4200")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 391-4306"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.internationalmusicco.com",
      "target": "_blank"
    }
  }, [_vm._v("www.internationalmusicco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Internationale Gesellschaft für Neue Musik")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(International Society for New Music)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sektion Österreich")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Ungargasse 11/12")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1030 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-23-63-803")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ignm.at",
      "target": "_blank"
    }
  }, [_vm._v("www.ignm.at")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Intitución Fernando el Católico")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Plaza de España, 2")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("50071 Zaragoza, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 976 288 878/79")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 976 288 869")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://ifc.dpz.es",
      "target": "_blank"
    }
  }, [_vm._v("http://ifc.dpz.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Intrepid Pixels")]), _vm._v(" Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("820 West End Avenue, Box 9E"), _c('br'), _vm._v("New York, NY 10025"), _c('br'), _vm._v("Tel: (212) 866-3939")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 280-8187")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ione Press,")]), _vm._v(" Inc. "), _c('b', [_vm._v("[5]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("138 Ipswich Street"), _c('br'), _vm._v("Boston, MA 02215")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (617) 236-1935")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (617) 236-0261")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Israel Music Institute")]), _vm._v(" (IMI) "), _c('b', [_vm._v("[13, 15]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("55 Menachem Begin Road"), _c('br'), _vm._v("67138 Tel Aviv, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (972) 3-624-70-95")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (972) 3-561-28-26"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.imi.org.il",
      "target": "_blank"
    }
  }, [_vm._v("www.imi.org.il")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Israeli Music Publications [13, 15]"), _c('br'), _vm._v("Japan Federation of Composers")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("#101, Mimori-Building"), _c('br'), _vm._v("1-19-4 Hatsudai")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Shibuya-Ku, Tokyo 151-0061 Japan")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (81) 3-6276-1177")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (81) 3-3376-3371"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.jfc.gr.jp",
      "target": "_blank"
    }
  }, [_vm._v("www.jfc.gr.jp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Japanese Society of Rights of Authors and Composers")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.jasrac.or.jp",
      "target": "_blank"
    }
  }, [_vm._v("www.jasrac.or.jp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Jaymar")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 2191, Stn. B"), _c('br'), _vm._v("London, Ontario N6A 4E3, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (519) 672-7369")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (519) 672-0016")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Jerona")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("224 King Street"), _c('br'), _vm._v("Englewood, NJ 07631")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (201) 568-8448")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (201) 569-7023")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Jean "), _c('b', [_vm._v("Jobert")]), _vm._v("/Editions Jobert et Cie "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("27 Boulevard Beaumarchais"), _c('br'), _vm._v("75004 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-56-68-86-60")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-56-68-90-66"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.jobert.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.jobert.fr")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Joclem")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[2]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Johnson")]), _vm._v(" Reprint Corp.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("111 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Joshua")]), _vm._v(" Corp. ("), _c('i', [_vm._v("see")]), _vm._v(" Boston Music Company)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editions Joubert [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("P. "), _c('b', [_vm._v("Jürgenson [14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2/46 Bolshaya Sadovaya St."), _c('br'), _vm._v("Moscow 123001, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (7) 495-254-8180")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (7) 495-609-0793"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.jurgenson.pro",
      "target": "_blank"
    }
  }, [_vm._v("www.jurgenson.pro")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("C. F. "), _c('b', [_vm._v("Kahnt [14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Frankfurt, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kallisti")]), _vm._v(" Music Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("810 S. Saint Bernard Street"), _c('br'), _vm._v("Philadelphia, PA 19143-3309")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (215) 724-6511 or (800) 260-2881"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.kallistimusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.kallistimusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edwin F. "), _c('b', [_vm._v("Kalmus [6, 8, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 5011"), _c('br'), _vm._v("Boca Raton, FL 33431")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 434-6340")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (561) 241-6347"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.efkalmus.com",
      "target": "_blank"
    }
  }, [_vm._v("www.efkalmus.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Edition Kemel")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Niedernhausen, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kenyon")]), _vm._v(" Publications "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("E. C. "), _c('b', [_vm._v("Kerby [10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Toronto, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Keturi")]), _vm._v(" Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 1120"), _c('br'), _vm._v("83251 Rimsting, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 8051-1634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 8051-63042"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.arends-musikverlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.arends-musikverlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("Keys Press")]), _vm._v(" (available through Theodore Front)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("66 Clotilde Street"), _c('br'), _vm._v("Mount Lawley"), _c('br'), _vm._v("Western Australia 6050, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (61-8) 9271-6547")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (61-8) 9271-6581"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.keyspress.com.au",
      "target": "_blank"
    }
  }, [_vm._v("www.keyspress.com.au")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Robert "), _c('b', [_vm._v("King")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("140 Main Street"), _c('br'), _vm._v("North Easton, MA 02356"), _c('br'), _vm._v("Fax: (508) 238-2571"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.rkingmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.rkingmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kistner & Siegel [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kultura [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kunzelmann")]), _vm._v(" (Switzerland) "), _c('b', [_vm._v("[6, 14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("La Jolla")]), _vm._v(" Publishing "), _c('b', [_vm._v("[9]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Musicales "), _c('b', [_vm._v("Labatiaz")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Case postale 112")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1890 St-Maurice, Switzerland"), _c('br'), _vm._v("Tel/Fax: (41) 24-485-24-80"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editions-labatiaz.com",
      "target": "_blank"
    }
  }, [_vm._v("www.editions-labatiaz.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Laurentius")]), _vm._v(" Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Dr. Wolfram Hader"), _c('br'), _vm._v("Stegerwaldstraße 21"), _c('br'), _vm._v("65929 Frankfurt a.M., Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 69-26-49-47-38")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 69-93-62-34-49"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.laurentius-musikverlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.laurentius-musikverlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lawson Gould")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lea")]), _vm._v(" Pocket Scores "), _c('b', [_vm._v("[2]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Alphonse "), _c('b', [_vm._v("Leduc [6, 13, 15]")]), _vm._v(" (also available in U.S. through Robert King)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("175, rue Saint-Honoré"), _c('br'), _vm._v("75040 Paris Cedex 01, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-42-96-89-11")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-42-86-02-83"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.alphonseleduc.com",
      "target": "_blank"
    }
  }, [_vm._v("www.alphonseleduc.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lee Roberts [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 341"), _c('br'), _vm._v("Chatham, NY 12037")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (518) 533-4921"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.leerobertsmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.leerobertsmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Leeds Music Corp.")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Leeds Music Ltd.")]), _vm._v(" (Canada) ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Robert Owen "), _c('b', [_vm._v("Lehman")]), _vm._v(" Foundation")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o The Morgan Library & Museum"), _c('br'), _vm._v("225 Madison Avenue"), _c('br'), _vm._v("New York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 685-0008"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.themorgan.org/research/collectionsMusic.asp",
      "target": "_blank"
    }
  }, [_vm._v("http://www.themorgan.org/research/collectionsMusic.asp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Henry "), _c('b', [_vm._v("Lemoine [6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("27 Boulevard Beaumarchais"), _c('br'), _vm._v("75004 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-56-68-86-65")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-56-68-90-66"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.henry-lemoine.com",
      "target": "_blank"
    }
  }, [_vm._v("www.henry-lemoine.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Alfred "), _c('b', [_vm._v("Lengnick")]), _vm._v(" ["), _c('i', [_vm._v("see also:")]), _vm._v(" William Elkin] "), _c('b', [_vm._v("[13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Wayne "), _c('b', [_vm._v("Leopold")]), _vm._v(" Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("8510 Triad Drive"), _c('br'), _vm._v("Colfax, NC 27235")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 765-3196"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wayneleupold.com",
      "target": "_blank"
    }
  }, [_vm._v("www.wayneleupold.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lerolle [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial "), _c('b', [_vm._v("Letras Cubanas")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Calle G, No. 505"), _c('br'), _vm._v("El Vedado"), _c('br'), _vm._v("Habana, Cuba"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ecured.cu/index.php/Editorial_Letras_Cubanas",
      "target": "_blank"
    }
  }, [_vm._v("www.ecured.cu/index.php/Editorial_Letras_Cubanas")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("F. E. C. "), _c('b', [_vm._v("Leuckart [6, 10]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rheingoldstr. 4"), _c('br'), _vm._v("80639 Munich, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 8917-3928")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 8917-6054")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lewis")]), _vm._v(" Music Publishing Co. "), _c('b', [_vm._v("[16]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Library of Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Music Division"), _c('br'), _vm._v("James Madison Memorial Bldg."), _c('br'), _vm._v("101 Independence Avenue, SE"), _c('br'), _vm._v("Washington, DC 20540-4710")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (202) 707-5507"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.loc.gov/rr/perform/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.loc.gov/rr/perform/")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Robert "), _c('b', [_vm._v("Lienau")]), _vm._v(" Musikverlag "), _c('b', [_vm._v("[6, 14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 69-978286-6")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 69-978286-79"), _c('br'), _vm._v("Frankfurt, Germany"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.lienau-frankfurt.de",
      "target": "_blank"
    }
  }, [_vm._v("www.lienau-frankfurt.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lingua Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 1192"), _c('br'), _vm._v("La Jolla, CA 92038")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Collection "), _c('b', [_vm._v("Litolff [14]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Longman [2]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1560 Broadway"), _c('br'), _vm._v("New York, NY 10036")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Harald "), _c('b', [_vm._v("Lyche")]), _vm._v(" & Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postboks 2171 Str"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/c1.jpg"
    }
  }), _vm._v("ms"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/c1.jpg"
    }
  }), _c('br'), _vm._v("3001 Drammen, Norway"), _c('br'), _vm._v("Tel: (47) 32-24-50-00")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lyrebird")]), _vm._v(" Press (Editions de l'Oiseau-Lyre)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Faculty of Music"), _c('br'), _vm._v("University of Melbourne"), _c('br'), _vm._v("VIC 3010, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (61) 3-8344-5346"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.lyrebirdpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.lyrebirdpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Vieira "), _c('b', [_vm._v("Machado")]), _vm._v(" Editores")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Maecenas")]), _vm._v(" Music "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5 Bushey Close"), _c('br'), _vm._v("Old Barn Lane"), _c('br'), _vm._v("Kenley, Surrey CR8 5AU"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-8660-3914")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-8668-5273"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.maecenasmusic.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.maecenasmusic.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Maestro")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Hansen House)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Pierre "), _c('b', [_vm._v("Mardaga")]), _vm._v(" Editeur, S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Avenue Pasteur 6—Bât. H"), _c('br'), _vm._v("1300 Wavre, Belgium"), _c('br'), _vm._v("Tel: (32) 10-686452"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mardaga.be",
      "target": "_blank"
    }
  }, [_vm._v("www.mardaga.be")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Margun/Gunmar Music [10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("167 Dudley Road"), _c('br'), _vm._v("Newton Center, MA 02159"), _c('br'), _vm._v("Tel: (617) 332-6398")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (617) 969-1079")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edward B. "), _c('b', [_vm._v("Marks [10, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("126 E. 38th Street"), _c('br'), _vm._v("New York, NY 10016"), _c('br'), _vm._v("Tel: (212) 779-7977")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 779-7920"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ebmarks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ebmarks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Masters")]), _vm._v(" Music Publications "), _c('b', [_vm._v("[6, 8, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("6403 W. Rogers Circle")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Boca Raton, FL 33487")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (561) 241-6169 or (800) 434-6340")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (561) 241-6347")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.masters-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.masters-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Materiali Sonori")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Tre Novembre 2")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("52027 San Giovanni Valdarno, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 559120363")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 559120370"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.matson.it",
      "target": "_blank"
    }
  }, [_vm._v("www.matson.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Kevin "), _c('b', [_vm._v("Mayhew [3, 6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buxhall"), _c('br'), _vm._v("Stowmarket"), _c('br'), _vm._v("Suffolk IP14 3BW"), _c('br'), _vm._v("United Kingdom"), _c('br'), _vm._v("Tel: (44) 845-388-1634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 1449-737834"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.kevinmayhew.com",
      "target": "_blank"
    }
  }, [_vm._v("www.kevinmayhew.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("MCA")]), _vm._v(" Music Publishing ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group) "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("McAfee")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("McGinnis & Marx [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("236 West 26th Street, #11S"), _c('br'), _vm._v("New York, NY 10001-6736"), _c('br'), _vm._v("Tel: (212) 675-1630")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 675-1630")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition Tilo "), _c('b', [_vm._v("Medek")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rheinhöhe, Westerwaldweg 22")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("53424 Remagen-Oberwinter, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 2228-8175")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 2228-8176"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.medek.net",
      "target": "_blank"
    }
  }, [_vm._v("www.medek.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Melos")]), _vm._v(" Ediciones Musicales "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tte. Gral. Juan D. Perón 1560"), _c('br'), _vm._v("C1037ACD Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (54) 11-4371-9841"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.melos.com.ar",
      "target": "_blank"
    }
  }, [_vm._v("www.melos.com.ar")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mercury")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[13, 15]")]), _vm._v(" (a subsidiary of TP)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.presser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.presser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Merion")]), _vm._v(" Music, Inc. "), _c('b', [_vm._v("[15, 17]")]), _vm._v(" (a subsidiary of TP)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.presser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.presser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Merseburger [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Naumburger Str. 40")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("43127 Kassel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 561-789809-11")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 561-789809-16"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.merseburger.de",
      "target": "_blank"
    }
  }, [_vm._v("www.merseburger.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Metropolis")]), _vm._v(" Editions "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Ediciones "), _c('b', [_vm._v("Mexicanas")]), _vm._v(" de Música "), _c('b', [_vm._v("[15]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mills")]), _vm._v(" Music "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Minkoff")]), _vm._v(" Musique et Musicologie / Éditions Minkoff")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("8, rue Eynar"), _c('br'), _vm._v("1211 Geneva 12, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (41-22) 310-46-60")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (41-22) 310-28-57")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mira")]), _vm._v(" Music Associates")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("199 Mountain Road"), _c('br'), _vm._v("Wilton, CT 06897-1526"), _c('br'), _vm._v("Tel: (302) 762-5186")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mitteldeutscher")]), _vm._v(" Verlag "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("MJQ")]), _vm._v(" Music "), _c('b', [_vm._v("[10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mobart")]), _vm._v(" Music Publications ("), _c('i', [_vm._v("see")]), _vm._v(" Boelke-Bomart)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Uitgeverij "), _c('b', [_vm._v("Moebiprint")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hercules Segherslaan 28"), _c('br'), _vm._v("1701 XB Heerhugowaard"), _c('br'), _vm._v("The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (31) 07-2571-5172")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Hermann "), _c('b', [_vm._v("Moeck")]), _vm._v(" Verlag "), _c('b', [_vm._v("[6, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 3131"), _c('br'), _vm._v("29231 Celle, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 5141-8853-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 5141-8853-42"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.moeck.com",
      "target": "_blank"
    }
  }, [_vm._v("www.moeck.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editio "), _c('b', [_vm._v("Moravia")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hvozdec 55"), _c('br'), _vm._v("664 71 Veverská Bítýška"), _c('br'), _vm._v("Tel/Fax: (420) 549-420-675"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editiomoravia.cz",
      "target": "_blank"
    }
  }, [_vm._v("www.editiomoravia.cz")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Moravian")]), _vm._v(" Music Foundation Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Assoc. University Presses"), _c('br'), _vm._v("440 Forsgate Drive"), _c('br'), _vm._v("Cranbury, NJ 08512"), _c('br'), _vm._v("Tel: (609) 655-4770")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edwin H. "), _c('b', [_vm._v("Morris [10]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("39 West 54th Street"), _c('br'), _vm._v("New York, NY 10019")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Karl Heinrich "), _c('b', [_vm._v("Möseler")]), _vm._v(" Verlag "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hoffmann-v.-F.-Str. 8")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("38304 Wolfenbüttel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 5331-95970")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 5331-959720"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.moeseler-verlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.moeseler-verlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mowbray")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[13, 15]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Willy "), _c('b', [_vm._v("Müller")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Bärenreiter)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musikverlag "), _c('b', [_vm._v("Müller & Schade")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Moserstrasse 16")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3014 Bern, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (41) 31-320-26-26")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (41) 31-320-26-27"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mueller-schade.com",
      "target": "_blank"
    }
  }, [_vm._v("www.mueller-schade.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Ediciones Musicales "), _c('b', [_vm._v("Mundimúsica")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Espejo, 4"), _c('br'), _vm._v("28013 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 91-548-17-94")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 91-548-17-53"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mundimusica.es",
      "target": "_blank"
    }
  }, [_vm._v("www.mundimusica.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Murdoch & Murdoch")]), _vm._v(" (London) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Music")]), _vm._v(" Graphics Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3409 Dickens Street"), _c('br'), _vm._v("San Diego, CA 92106"), _c('br'), _vm._v("Tel: (619) 523-1962")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Music Press [7]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Music Sales Limited [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Newmarket Road"), _c('br'), _vm._v("Bury St. Edmund"), _c('br'), _vm._v("Suffolk IP33 3YB, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Music Treasure")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("620 Fort Washington Avenue, #1F"), _c('br'), _vm._v("New York, NY 10040-3930")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musica Islandica")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Iceland Music Information Centre"), _c('br'), _vm._v("Sidumuli 34")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("108 Reykjavik, Iceland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (354) 568-3122")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (354) 568-3124"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mic.is",
      "target": "_blank"
    }
  }, [_vm._v("www.mic.is")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial "), _c('b', [_vm._v("Musica Moderna [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editora "), _c('b', [_vm._v("Música Nova")]), _vm._v(" do Brasil")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua Pres. Carlos de Campos 115"), _c('br'), _vm._v("bl.02/902"), _c('br'), _vm._v("22231-080 Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (55) 21-2553-6222")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (55) 21-2553-9963"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.sites.uol.com.br/marlosnobre",
      "target": "_blank"
    }
  }, [_vm._v("www.sites.uol.com.br/marlosnobre")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musica Obscura")]), _vm._v(" Editions "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("17 Joey Road")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Merrimack, NH 03054-4549")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (603) 881-7210")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (603) 595-8382")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musica Rara [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("215 Bailey Avenue"), _c('br'), _vm._v("Rock Hill, SC 29732-1003")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (803) 366-4446")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (803) 212-0016"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musicarara.com",
      "target": "_blank"
    }
  }, [_vm._v("www.musicarara.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editora "), _c('b', [_vm._v("Musical Brasileira")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musical Scope")]), _vm._v(" Publishers "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musikk-Huset")]), _vm._v(" Forlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postbox 1499 Vika"), _c('br'), _vm._v("0116 Oslo, Norway"), _c('br'), _vm._v("Tel: (47) 22-82-59-00")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (47) 22-82-59-01"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musikk-huset.no",
      "target": "_blank"
    }
  }, [_vm._v("www.musikk-huset.no")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musikwissenschaftlichen [14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Dorotheergasse 10"), _c('br'), _vm._v("1010 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-515-03-43")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-515-03-51"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mwv.at",
      "target": "_blank"
    }
  }, [_vm._v("www.mwv.at")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Muzblka")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Moscow, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editura "), _c('b', [_vm._v("Muzicală")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Calea Victoriei nr. 141, sector 1")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("71102 Bucharest, Romania"), _c('br'), _vm._v("Tel/Fax: (40) 21-312-98-67"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edituramuzicala.ro",
      "target": "_blank"
    }
  }, [_vm._v("www.edituramuzicala.ro")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Nagel's")]), _vm._v(" Musik-Archive ("), _c('i', [_vm._v("see")]), _vm._v(" Bärenreiter)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Arthur "), _c('b', [_vm._v("Napoleão [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musikedition "), _c('b', [_vm._v("Nepomuk")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" HBS Nepomuk)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("New Music Edition [7, 10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("New Music USA")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("90 John Street, Suite 312"), _c('br'), _vm._v("New York City, NY 10038")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 645-6949")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (646) 490-0998"), _c('br'), _c('a', {
    attrs: {
      "href": "http://library.newmusicusa.org",
      "target": "_blank"
    }
  }, [_vm._v("library.newmusicusa.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("New Music West")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1437 Crest Drive"), _c('br'), _vm._v("Altadena, CA 91001"), _c('br'), _vm._v("Tel: (626) 794-1684")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("New World Music")]), _vm._v(" Corp. "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Pierre "), _c('b', [_vm._v("Noël")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Billaudot)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Otto Heinrich "), _c('b', [_vm._v("Noetzel")]), _vm._v(" Verlag "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Liebigstraße 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("26389 Wilhelmshaven, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 4421-9267-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 4421-9267-99"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.heinrichshofen.de",
      "target": "_blank"
    }
  }, [_vm._v("www.heinrichshofen.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Nordiska")]), _vm._v(" Musikförlaget "), _c('b', [_vm._v("[6, 16]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Gehrmans Musikförlag"), _c('br'), _vm._v("Box 42026")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("126 12 Stockholm, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (46) 8-610-06-00")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (46) 8-610-06-27")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Norruth")]), _vm._v(" Music "), _c('b', [_vm._v("[12]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("St. Louis, MO 63103")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Norsk")]), _vm._v(" Musikforläg "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postboks 1499 Vika"), _c('br'), _vm._v("0116 Oslo, Norway")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (47) 23-00-21-10")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (47) 23-00-20-11"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.norskmusikkforlag.no",
      "target": "_blank"
    }
  }, [_vm._v("www.norskmusikkforlag.no")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Norton")]), _vm._v(" Critical Scores")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("W. W. Norton"), _c('br'), _vm._v("500 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10110"), _c('br'), _vm._v("Tel: (800) 233-4830 or (212) 354-5500")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 869-0856"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wwnorton.com",
      "target": "_blank"
    }
  }, [_vm._v("www.wwnorton.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Nottingham")]), _vm._v(" Square Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Music Publishing Services"), _c('br'), _vm._v("236 W. 26th Street, Suite 11-S"), _c('br'), _vm._v("New York, NY 10001"), _c('br'), _vm._v("Tel: (212) 243-5233")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 675-1630")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editora "), _c('b', [_vm._v("Novas Metas")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("São Paulo, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Novello [6, 10, 13, 16, 17]")]), _vm._v(" (now part of Music Sales Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("14-15 Berners Street"), _c('br'), _vm._v("London W1T 3LJ"), _c('br'), _vm._v("United Kingdom"), _c('br'), _vm._v("Tel: (44) 20-7612-7400")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-7612-7545"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chesternovello.com",
      "target": "_blank"
    }
  }, [_vm._v("www.chesternovello.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Oertel")]), _vm._v(" Verlag "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Oesterreichischer Bundesverlag")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Frankgasse 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1090 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-401-36-36")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-401-36-60"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.oebv.at",
      "target": "_blank"
    }
  }, [_vm._v("www.oebv.at")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions de l"), _c('b', [_vm._v("'Oiseau-Lyre [6, 11, 17]")]), _vm._v(" (now taken over by Lyrebird Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("OMI")]), _vm._v(" (Old Manuscripts and Incunabula)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 6019 FDR Station"), _c('br'), _vm._v("New York, NY 10150")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 758-1946")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 593-6186"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.omifacsimiles.com",
      "target": "_blank"
    }
  }, [_vm._v("www.omifacsimiles.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ongaku-No-Tomo-Sha [6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ongakunotomo.co.jp",
      "target": "_blank"
    }
  }, [_vm._v("www.ongakunotomo.co.jp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Orphée [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1240 Clubview Blvd. N."), _c('br'), _vm._v("Columbus, OH 43235-1226")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (614) 846-9517")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (614) 846-9794"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editionsorphee.com",
      "target": "_blank"
    }
  }, [_vm._v("www.editionsorphee.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Les Éditions "), _c('b', [_vm._v("Ouvrières")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Alphonse Leduc)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Oxford")]), _vm._v(" University Press "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("198 Madison Avenue"), _c('br'), _vm._v("New York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 726-6000"), _c('br'), _c('i', [_vm._v("Customer Service")]), _vm._v(" (Orders):"), _c('br'), _vm._v("2001 Evans Road"), _c('br'), _vm._v("Cary, NC 27513")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 411-5445")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (919) 677-1303"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.oup.com/us",
      "target": "_blank"
    }
  }, [_vm._v("www.oup.com/us")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Pan American Union")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Peermusic)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Panton")]), _vm._v(" International ("), _c('i', [_vm._v("see")]), _vm._v(" European American Music Distributors)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Papagena")]), _vm._v(" Press "), _c('b', [_vm._v("[6, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Box 20484, Park West Station"), _c('br'), _vm._v("New York, NY 10025")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 316-2235"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.papagenapress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.papagenapress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Papagrigoriou-Nakas")]), _vm._v(" Music Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(Ch. Nakas—C. Papagrigoriou Co.)"), _c('br'), _vm._v("39 Panepistimiou Street"), _c('br'), _vm._v("105 64 Athens, Greece")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (30) 210-32-21-786")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (30) 210-32-22-742"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.panasmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.panasmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Paragon")]), _vm._v(" Music Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Brentwood-Benson Music"), _c('br'), _vm._v("Publishing"), _c('br'), _vm._v("5409 Maryland Way, Suite 200"), _c('br'), _vm._v("Brentwood, TN 37027")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (615) 371-1320")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (615) 371-1351"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musicservices.org",
      "target": "_blank"
    }
  }, [_vm._v("www.musicservices.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Parnaso")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua N.S. Fatima, 231"), _c('br'), _vm._v("Porto, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("W. "), _c('b', [_vm._v("Paxton [6]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Music Sales Ltd)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("London, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Peer International")]), _vm._v(" has become part of Peermusic Classical (810 Seventh Avenue, New York, NY 10019) "), _c('b', [_vm._v("[6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("250 W. 57th St., Suite 820")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("New York, NY 10107")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 265-3910")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 489-2465"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.peermusicclassical.com",
      "target": "_blank"
    }
  }, [_vm._v("www.peermusicclassical.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Pennsylvania State")]), _vm._v(" Music Series Publication of this series was discontinued in the 1970s; no longer available from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. W. "), _c('b', [_vm._v("Pepper & Son")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2480 Industrial Blvd."), _c('br'), _vm._v("Paoli, PA 19301"), _c('br'), _vm._v("Tel: (800) 345-6296 or (610) 648-0500")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (610) 993-0563"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.jwpepper.com",
      "target": "_blank"
    }
  }, [_vm._v("www.jwpepper.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Permanent Press,")]), _vm._v(" Music of Quality")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("7508 42nd Avenue, NE"), _c('br'), _vm._v("Seattle, WA 98115"), _c('br'), _vm._v("Tel: (206) 525-6596")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Philharmusica Edition [8]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.philharmusica.com",
      "target": "_blank"
    }
  }, [_vm._v("www.philharmusica.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions "), _c('b', [_vm._v("Philippo")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Éditions Combres"), _c('br'), _vm._v("27 Boulevard Beaumarchais"), _c('br'), _vm._v("75004 Paris, France"), _c('br'), _vm._v("Tel: (33) 1-56-68-86-64")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-56-68-90-66"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editions-combre.com",
      "target": "_blank"
    }
  }, [_vm._v("www.editions-combre.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Prhythm [1, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Pioneer")]), _vm._v(" Editions ("), _c('i', [_vm._v("see")]), _vm._v(" American Composers Alliance)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Piwarski")]), _vm._v(" Verlag "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Cracow, Poland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Plymouth")]), _vm._v(" Music "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("170 NE 33rd Street"), _c('br'), _vm._v("Fort Lauderdale, FL 33334")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (305) 563-1844")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (305) 563-9006")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Polish Music Publications/")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Polskie Wydawnictwo Muzyczne")]), _vm._v(" [PWM] "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("al. Krasinskiego 11a"), _c('br'), _vm._v("31-111 Krakow, Poland"), _c('br'), _vm._v("Tel/Fax: (48-12) 422-71-71"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.pwm.com.pl",
      "target": "_blank"
    }
  }, [_vm._v("www.pwm.com.pl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Poon Hill")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.poonhill.com",
      "target": "_blank"
    }
  }, [_vm._v("www.poonhill.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Price Milburn [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Wellington, New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Printed Editions")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 27"), _c('br'), _vm._v("Barrytown, NY 12507")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Pro Organo [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Brühlstraße 42")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("88299 Leutkirch, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 7561-3398")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 7561-72188"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.pro-organo.com",
      "target": "_blank"
    }
  }, [_vm._v("www.pro-organo.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Promethean")]), _vm._v(" Editions "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 10143"), _c('br'), _vm._v("Wellington, New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (64) 4-473-5033")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (64) 4-473-5066"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.promethean-editions.co.nz",
      "target": "_blank"
    }
  }, [_vm._v("www.promethean-editions.co.nz")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("PRO/Scribes")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("734 Wolcott Drive"), _c('br'), _vm._v("Philadelphia, PA 19118")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Providence")]), _vm._v(" Music Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 2362"), _c('br'), _vm._v("East Side Station"), _c('br'), _vm._v("Providence, RI 02906")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Keith "), _c('b', [_vm._v("Prowse")]), _vm._v(" Music Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("London, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Publicacions de l'Abadia de Montserrat")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Carrer d'Ausiàs Marc, 92-98"), _c('br'), _vm._v("0813 Barcelona, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 93-24-50-303")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 93-24-73-594"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.pamsa.cat/pamsa/inici",
      "target": "_blank"
    }
  }, [_vm._v("www.pamsa.cat/pamsa/inici")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Queen's Temple Publications [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("15 Mallard Drive"), _c('br'), _vm._v("Buckingham")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buckinghamshire MK18 1GJ United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel/Fax: (44) 1280-813144"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.qtpublications.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.qtpublications.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Radiodifusão Portuguesa")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Av. Duarte Pacheco, no.5-4"), _c('br'), _vm._v("Lisbon, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("D. "), _c('b', [_vm._v("Rahter [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Basil "), _c('b', [_vm._v("Ramsey [13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("604 Rayleigh Road"), _c('br'), _vm._v("Eastwood Leigh-on-Sea"), _c('br'), _vm._v("Essex SS9 5HU"), _c('br'), _vm._v("United Kingdom"), _c('br'), _vm._v("Tel: (44) 1702-524305")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 1702-526142")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Raptus")]), _vm._v(" Edition")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 3698")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Amsterdam, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Recital Publications [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 1697"), _c('br'), _vm._v("Huntsville, TX 77342-1697")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel/Fax: (936) 295-6929"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.recitalpublications.com",
      "target": "_blank"
    }
  }, [_vm._v("www.recitalpublications.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Redcliffe")]), _vm._v(" Edition")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("68 Barrowgate Road"), _c('br'), _vm._v("London W4 4HD"), _c('br'), _vm._v("United Kingdom"), _c('br'), _vm._v("Tel: (020) 8995-1223")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Remick")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Reuter & Reuter")]), _vm._v(" Forlags")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 55755")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("11483 Stockholm, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (46) 86-29-53-70")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("G. "), _c('b', [_vm._v("Ricordi")]), _vm._v(" & Co. (International) "), _c('b', [_vm._v("[2, 6, 13, 10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Benigno Crespi, 19")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20159 Milan, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 2-80282-811")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 2-80282-882"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ricordi.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ricordi.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ricordi Americana")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" ALMA, Inc., and G. Ricordi & Co.) "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ricordi BA")]), _vm._v(" (Argentina) "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ricordi BR")]), _vm._v(" (Brazil) ("), _c('i', [_vm._v("see")]), _vm._v(" ALMA, Inc.) "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ries & Erler")]), _vm._v(" (Germany) "), _c('b', [_vm._v("[6, 7, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Wandalenalle 8")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("14052 Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 30-825-10-49")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 30-825-97-21"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.rieserler.de",
      "target": "_blank"
    }
  }, [_vm._v("www.rieserler.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Robbins")]), _vm._v(" Music "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Roberton")]), _vm._v(" Publications "), _c('b', [_vm._v("[13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Aylesbury, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Winthrop "), _c('b', [_vm._v("Rogers")]), _vm._v(" Edition "), _c('b', [_vm._v("[2]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Romcan")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("115 Orange Street"), _c('br'), _vm._v("Beaufort, NC 28516"), _c('br'), _vm._v("Tel: (252) 728-2542")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Rongwen")]), _vm._v(" Music "), _c('b', [_vm._v("[2, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("E. "), _c('b', [_vm._v("Rouart, Lerolle & Co.")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Salabert)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Rozsavölgi [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Budapest, Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Russian Music Publishers [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 49 ‘RMP’"), _c('br'), _vm._v("Moscow 105120, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (7) 495-928-0571")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (7) 495-911-3132"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.rmi.ru",
      "target": "_blank"
    }
  }, [_vm._v("www.rmi.ru")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Salabert [2, 6, 8, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.durand-salabert-eschig.com",
      "target": "_blank"
    }
  }, [_vm._v("www.durand-salabert-eschig.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Samfundet:")]), _vm._v(" Society for the Publication of Danish Music "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Gråbrødrestræde 18, 1")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1156 Copenhagen K, Denmark")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (45) 33-13-54-45")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (45) 33-93-30-44"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.samfundet.dk",
      "target": "_blank"
    }
  }, [_vm._v("www.samfundet.dk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("San Andreas")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 60247"), _c('br'), _vm._v("Palo Alto, CA 94306")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (650) 856-9394"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.scoremus.com",
      "target": "_blank"
    }
  }, [_vm._v("www.scoremus.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Sassetti")]), _vm._v(" & Cia.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("R. Nova do Almada, 60"), _c('br'), _vm._v("Lisbon 2, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. S. "), _c('b', [_vm._v("Sato,")]), _vm._v(" Music Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 14854"), _c('br'), _vm._v("Chicago, IL 60614-0854")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (773) 296-0893")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (773) 296-0936"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.satomusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.satomusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Scala Aretina")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Ediciones Musicales"), _c('br'), _vm._v("Apartado de Correos 175")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("25230 Mollerussa, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Richard "), _c('b', [_vm._v("Schauer")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("London, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schaum")]), _vm._v(" Publications, Inc. "), _c('b', [_vm._v("[1, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10235 North Port Washington Rd."), _c('br'), _vm._v("Mequon, WI 53092")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 786-5023 or (262) 241-5013")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (262) 241-1063"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schaumpiano.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schaumpiano.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("’Schlesinger'sche")]), _vm._v(" Musikhandlung "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Arthur P. "), _c('b', [_vm._v("Schmidt")]), _vm._v(" Co. "), _c('b', [_vm._v("[1]")]), _vm._v(" (see Summy-Birchard)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schott")]), _vm._v(" Music International "), _c('b', [_vm._v("[6, 8, 10, 11, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("254 W. 31st Street"), _c('br'), _vm._v("New York, NY 10001")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 461-6940")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 810-4564"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schott-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schott-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schott")]), _vm._v(" Frères ("), _c('i', [_vm._v("see")]), _vm._v(" Schott Music Internationa) "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schroeder & Gunther [10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schultheiss")]), _vm._v(" Musikverlag, C.L. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tübingen, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schultz")]), _vm._v(" Music Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5637 Beacon Street"), _c('br'), _vm._v("Pittsburgh, PA 15217"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schultzmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schultzmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schwann")]), _vm._v(" Musikverlag "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Scottish Music Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("City Halls, Candleriggs"), _c('br'), _vm._v("Glasgow G1 1NQ"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 141-552-5222")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 141-553-2789"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.scottishmusiccentre.com",
      "target": "_blank"
    }
  }, [_vm._v("www.scottishmusiccentre.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Charles "), _c('b', [_vm._v("Scribner")]), _vm._v("'s Sons")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Simon & Schuster"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.simonandschuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonandschuster.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Seda Productions")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Seda Publications)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Seda Publications")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("45 Common Street"), _c('br'), _vm._v("Belmont, MA 02478-3022")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (617) 489-1848")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (617) 489-6474")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Seesaw")]), _vm._v(" Music Corp. ("), _c('i', [_vm._v("see")]), _vm._v(" Subito Music) "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Maurice "), _c('b', [_vm._v("Senart")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Salabert)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Servico de Documentacao Musical")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("da Ordem dos Musicos do Brasil"), _c('br'), _vm._v("Av. Almte. Barroso, 72-7 Andar"), _c('br'), _vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Shawnee")]), _vm._v(" Press "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 962-8584"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.shawneepress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.shawneepress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Sikesdi Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1102 Bellevue Avenue SE"), _c('br'), _vm._v("Calgary, Alberta T2G 4LI, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (403) 262-1201")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Hans "), _c('b', [_vm._v("Sikorski [6, 8, 10, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Johnsallee 23")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20148 Hamburg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 40 41 41 00 0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 40 41 41 00 40")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sikorski.de",
      "target": "_blank"
    }
  }, [_vm._v("www.sikorski.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("N. "), _c('b', [_vm._v("Simrock [2, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Sisra")]), _vm._v(" Publications ("), _c('i', [_vm._v("see")]), _vm._v(" Arsis Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Skandinavisk")]), _vm._v(" Musikförlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.nodelageret.dk",
      "target": "_blank"
    }
  }, [_vm._v("www.nodelageret.dk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Skandinavisk")]), _vm._v(" og Borups Musikförlag "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Copenhagan, Denmark")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Smith")]), _vm._v(" Publications/Sonic Art Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("54 Lent Road"), _c('br'), _vm._v("Sharon, VT 05065"), _c('br'), _vm._v("Tel: (802) 765-4714"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.smith-publications.com",
      "target": "_blank"
    }
  }, [_vm._v("www.smith-publications.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Société des Nouvelles Editions Liègeoises")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("("), _c('i', [_vm._v("see")]), _vm._v(" Mardaga)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Société Française de Musicologie [17]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Minkoff)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Société Liègeoise de Musicologie")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rue Curtius, 11")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("4020 Liège, Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (32) 4-366-58-50"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.slgm.ulg.ac.be",
      "target": "_blank"
    }
  }, [_vm._v("www.slgm.ulg.ac.be")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Fundación Vincente Emilio "), _c('b', [_vm._v("Sojo")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Avenida Santiago de Chile"), _c('br'), _vm._v("No. 17, Los Caebos"), _c('br'), _vm._v("Apartado Postal 70537"), _c('br'), _vm._v("Caracas 1071, Venezuela")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (58) 2-793-57-17 or (58) 2-793-49-48")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (58) 2-793-59-82")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Sonos")]), _vm._v(" Music Resources "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Soundings")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("948 Canyon Road"), _c('br'), _vm._v("Sante Fe, NM 87501")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("Southern Baptist Theological Seminary")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("James P. Boyce Library"), _c('br'), _vm._v("2825 Lexington Road"), _c('br'), _vm._v("Louisville, KY 40280")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (502) 897-4713"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.library.sbts.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.library.sbts.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Southern")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 329"), _c('br'), _vm._v("San Antonio, TX 78292")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (210) 226-8167")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (210) 223-4537"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.southernmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.southernmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Soviet Composers / Sovetskii Kompozitor")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Moscow, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Leo "), _c('b', [_vm._v("Sowerby")]), _vm._v(" Foundation "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2 Congress Street"), _c('br'), _vm._v("Worcester, MA 01609-2003")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (508) 755-7906")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Special Music Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Maur, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Stainer & Bell [5, 6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 110, Victoria House"), _c('br'), _vm._v("23 Gruneisen Road"), _c('br'), _vm._v("London N3 1DZ"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-8343-3303")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-8343-3024"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.stainer.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.stainer.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Thomas C. "), _c('b', [_vm._v("Stangland [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 19263"), _c('br'), _vm._v("Portland, OR 97280-0263")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (503) 244-0634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (208) 485-4393")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Stat hudbeni vydavateiski")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Supraphon)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Steingräber")]), _vm._v(" Verlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.steingraeber-musikverlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.steingraeber-musikverlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Stockhausen")]), _vm._v(" Verlag "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Stockhausen Foundation for Musik"), _c('br'), _vm._v("51515 Kürten, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 2268-1813"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.stockhausen.org",
      "target": "_blank"
    }
  }, [_vm._v("www.stockhausen.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Studio P/R [1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Subito")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[2, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("60 Depot Street"), _c('br'), _vm._v("Verona, NJ 07044")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (973) 857-3440")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (973) 857-3442"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.subitomusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.subitomusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Süddeutscher")]), _vm._v(" Musikverlag "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Heidelberg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Summy-Birchard [2]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("15800 NW 48th Avenue"), _c('br'), _vm._v("Miami, FL 33014"), _c('br'), _vm._v("Tel: (305) 620-1500")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (305) 621-1094")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Supraphon")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Palackého 1 / 740")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("112 99 Prague 1, Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (420) 221-966-600")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (420) 221-966-630"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.supraphon.com",
      "target": "_blank"
    }
  }, [_vm._v("www.supraphon.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Swan")]), _vm._v(" & Co. (England) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("London, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Templeton")]), _vm._v(" Publishing Co. ("), _c('i', [_vm._v("see")]), _vm._v(" Shawnee Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tempo")]), _vm._v(" Praha/Bote & Bock "), _c('b', [_vm._v("[15]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tenuto")]), _vm._v(" Publications "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.tritone-tenuto.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tritone-tenuto.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tetra")]), _vm._v(" Music Corp. ("), _c('i', [_vm._v("see")]), _vm._v(" Plymouth Music Co.) "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Thames")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Gordon V. "), _c('b', [_vm._v("Thompson [1]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("29 Birch Avenue"), _c('br'), _vm._v("M4V 1E2 Toronto, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (416) 227-0566")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (416) 227-0573")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Thorpe")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.thorpemusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thorpemusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("P. J. "), _c('b', [_vm._v("Tonger [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Haid-und-Neu-Straße 18")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("76131 Karlsruhe, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 721-62-68-56-6 or")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(49) 221-93-55-64-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.tonger.de",
      "target": "_blank"
    }
  }, [_vm._v("www.tonger.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tonos")]), _vm._v(" Musikverlags "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lange Straße 89a"), _c('br'), _vm._v("76530 Baden-Baden, Germany"), _c('br'), _vm._v("Tel: (49) 7221 97370 0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 7221 97370 27"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.tonosmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tonosmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("To-oN Kikau")]), _vm._v(" Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1-15-1 Sugamo"), _c('br'), _vm._v("Toshima-ku"), _c('br'), _vm._v("Tokyo, Japan 170"), _c('br'), _vm._v("Tel: (81-3) 39441581")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (81-3) 39442130")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Ediziun "), _c('b', [_vm._v("Trais Giats")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("7546 Ardez, Switzerland"), _c('br'), _vm._v("Tel/Fax: (41) 81-862-22-34"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.trais-giats.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.trais-giats.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Transcontinental")]), _vm._v(" Music Publications/New Jewish Music Press "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("URJ Books & Music"), _c('br'), _vm._v("633 Third Avenue, 7th Floor"), _c('br'), _vm._v("New York, NY 10017-6778")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 650-4120")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 650-4119"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.transcontinentalmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.transcontinentalmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tre Media")]), _vm._v(" Musikverlage")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Friederike Zimmermann"), _c('br'), _vm._v("Amalienstrasse 40"), _c('br'), _vm._v("76133 Karlsruhe, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 721-26023")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 721-26044"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.tremediamusicedition.de",
      "target": "_blank"
    }
  }, [_vm._v("www.tremediamusicedition.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tritó [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Enamorats, 35-37 baixos"), _c('br'), _vm._v("08013 Barcelona, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 933-426-175")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 933-022-670"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.trito.es",
      "target": "_blank"
    }
  }, [_vm._v("www.trito.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial "), _c('b', [_vm._v("Tritone [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lima, Peru")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Unión Musical Ediciones [6, 10, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(part of Music Sales Group)"), _c('br'), _vm._v("Marqués de la Ensenada, 4"), _c('br'), _vm._v("28004 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 91-308-4040")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 91-310-4429"), _c('br'), _c('a', {
    attrs: {
      "href": "http://unionmusicalediciones.com",
      "target": "_blank"
    }
  }, [_vm._v("unionmusicalediciones.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Unión Musical Española [16]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Carrera de San Jerónimo, 26"), _c('br'), _vm._v("28014 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 902-112-859"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.unionmusical.es",
      "target": "_blank"
    }
  }, [_vm._v("www.unionmusical.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("United")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3 Abbey Point"), _c('br'), _vm._v("Cartersfield Road"), _c('br'), _vm._v("Waltham Abbey"), _c('br'), _vm._v("Essex EN9 1FE"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 1992-703110")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 1992-767682"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ump.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.ump.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Universal Edition [6, 8, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Karlsplatz 6"), _c('br'), _vm._v("1010 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-337-23-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-337-23-400"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.universaledition.com",
      "target": "_blank"
    }
  }, [_vm._v("www.universaledition.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Universal Music")]), _vm._v(" Publishing Group")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2100 Colorado Avenue"), _c('br'), _vm._v("Santa Monica, CA 90404"), _c('br'), _vm._v("Tel: (310) 235-4700")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (310) 235-4900"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.umusicpub.com",
      "target": "_blank"
    }
  }, [_vm._v("www.umusicpub.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("University of California Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2120 Berkeley Way"), _c('br'), _vm._v("Berkeley, CA 94704"), _c('br'), _vm._v("Tel: (800) 777-4726 (orders) or")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(510) 642-4247")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (510) 643-7127"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ucpress.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.ucpress.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("University of Washington Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 50096"), _c('br'), _vm._v("Seattle, WA 98145")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 537-5487 (orders)"), _c('br'), _vm._v("or (206) 543-4050")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (206) 543-3932"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.washington.edu/uwpress",
      "target": "_blank"
    }
  }, [_vm._v("www.washington.edu/uwpress")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("University of Virginia Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 400318"), _c('br'), _vm._v("Charlottesville, VA 22904")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 831-3406")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (877) 288-6400"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.upress.virginia.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.upress.virginia.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("University Society")]), _vm._v(" Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("145 N. Franklin Turnpike"), _c('br'), _vm._v("Ramsey, NJ 07446")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (201) 327-1982")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Urbanek")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Artia)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ut Orpheus")]), _vm._v(" Edizioni "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Piazza di Porta Ravegnana 1")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("40126 Bologna, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 051-226468")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 051-263720"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.utorpheus.com",
      "target": "_blank"
    }
  }, [_vm._v("www.utorpheus.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Valley")]), _vm._v(" Music Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Northampton, MA"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.valleymusicpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.valleymusicpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Van Rossum")]), _vm._v(" (Netherlands) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Vereniging voor Nederlandse")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('b', [_vm._v("Muziekgeschiedenis")]), _vm._v(" (Dutch Society for Musicology)"), _c('br'), _vm._v("Postbus 1514"), _c('br'), _vm._v("3500 BM Utrecht"), _c('br'), _vm._v("The Netherlands"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.kvnm.nl",
      "target": "_blank"
    }
  }, [_vm._v("http://www.kvnm.nl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Verlag für Musikalische Kultur und Wissenschaft")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Wolfenbüttel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Verlag Neue Musik")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Grabbeallee 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("13156 Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 30 61 69 81 0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 30 61 69 81 21"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.verlag-neue-musik.de",
      "target": "_blank"
    }
  }, [_vm._v("www.verlag-neue-musik.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Vienna Masterworks")]), _vm._v(" (BMI)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Margaretenstrasse 125/15"), _c('br'), _vm._v("1050 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Vienna Urtext")]), _vm._v(" Editions "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Forsthausgasse 9"), _c('br'), _vm._v("1200 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-33723-226")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-33723-425"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wiener-urtext.com",
      "target": "_blank"
    }
  }, [_vm._v("www.wiener-urtext.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musikverlag C. F. "), _c('b', [_vm._v("Vieweg [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Viking")]), _vm._v(" Musikförlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lille Strandvej 3")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2900 Hellerup"), _c('br'), _vm._v("Copenhagen, Denmark")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (45) 31-62-12-10")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Visible")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1037 Park Avenue"), _c('br'), _vm._v("Amherst, OH 44001"), _c('br'), _vm._v("Tel: (440) 984-4037"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.visible-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.visible-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Irmãos "), _c('b', [_vm._v("Vitale")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua França Pinto, 42"), _c('br'), _vm._v("São Paulo, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (11) 5081-9499")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (11) 5574-7388"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.vitale.com.br",
      "target": "_blank"
    }
  }, [_vm._v("www.vitale.com.br")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Vivace")]), _vm._v(" Press "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("University of Missouri"), _c('br'), _vm._v("1 University Boulevard"), _c('br'), _vm._v("265 General Services Building")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (314) 516-4990")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (314) 516-4992"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.vivacepress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.vivacepress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Arno "), _c('b', [_vm._v("Volk")]), _vm._v(" Verlag ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Walhall")]), _vm._v(" / Verlag Franz Biersack "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Richard-Wagner Straße 3")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("39106 Magdeburg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 391-85-78-20")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 391-8-52-00-79"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edition-walhall.de",
      "target": "_blank"
    }
  }, [_vm._v("www.edition-walhall.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Walton")]), _vm._v(" Music "), _c('b', [_vm._v("[2, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1028 Highland Woods Rd."), _c('br'), _vm._v("Chapel Hill, NC 27517")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (919) 929-1330")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (919) 929-2232"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.waltonmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.waltonmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Warner Brothers")]), _vm._v(" Publications "), _c('b', [_vm._v("[1, 13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Warner/Chappell")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10585 Santa Monica Boulevard"), _c('br'), _vm._v("Los Angeles, CA 90025-4950")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (310) 441-8600")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (310) 441-8780"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.warnerchappell.com",
      "target": "_blank"
    }
  }, [_vm._v("www.warnerchappell.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Waterloo")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[4]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Carlo "), _c('b', [_vm._v("Wehrs")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Ac/de Eulenstein Musica S.A."), _c('br'), _vm._v("Rua Rute Ferreira, 258"), _c('br'), _vm._v("(ZC-22-Ramos)"), _c('br'), _vm._v("20000 Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Josef "), _c('b', [_vm._v("Weinberger [2, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("12-14 Mortimer Street"), _c('br'), _vm._v("London W1T 3JJ, Great Britain"), _c('br'), _vm._v("Tel: (44) 20-7580-2827")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-7436-9616"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.josef-weinberger.com",
      "target": "_blank"
    }
  }, [_vm._v("www.josef-weinberger.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Weintraub")]), _vm._v(" Music "), _c('b', [_vm._v("[16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Westerlund [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Helsinki, Finland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Western International Music")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3707 65th Avenue"), _c('br'), _vm._v("Greeley, CO 80634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (970) 330-6901")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (970) 330-7738"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wiminc.com",
      "target": "_blank"
    }
  }, [_vm._v("www.wiminc.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Western Music,")]), _vm._v(" Ltd. (Canada) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Joseph "), _c('b', [_vm._v("Williams")]), _vm._v(" Editions (England) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Willis")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("7380 Industrial Road")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 548"), _c('br'), _vm._v("Florence, KY 41042")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 354-9799 or (859) 283-2050")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (859) 283-1784"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.willismusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.willismusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Wimbledon")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Trigram Music Inc./Wimbledon Music "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1801 Century Park East, Suite 2400"), _c('br'), _vm._v("Los Angeles, CA 90067")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (310) 556-9683")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (310) 277-1278"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wimbtri.net",
      "target": "_blank"
    }
  }, [_vm._v("www.wimbtri.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Witmark & Sons [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Walter "), _c('b', [_vm._v("Wollenweber")]), _vm._v(" Verlag "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Munich, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Yorktown")]), _vm._v(" Music Press "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("G. "), _c('b', [_vm._v("Zanibon [10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("c/o "), _c('b', [_vm._v("Armelin")]), _vm._v(" Musica")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via dei Soncin, 42"), _c('br'), _vm._v("35122 Padova, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 49-8724-928")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 49-8736-524"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.zanibon.it",
      "target": "_blank"
    }
  }, [_vm._v("www.zanibon.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Zen-on")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[6, 10, 11, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2-13-3 Kami Ochiai"), _c('br'), _vm._v("Shinjuku-ku, Tokyo 161-0034"), _c('br'), _vm._v("Japan"), _c('br'), _vm._v("Tel: (81) 3-3227-6283")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (81) 3-3227-6288"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.zen-on.co.jp",
      "target": "_blank"
    }
  }, [_vm._v("www.zen-on.co.jp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Zenmükiado")]), _vm._v(" Vallalat ("), _c('i', [_vm._v("see")]), _vm._v(" Editio Musica "), _c('b', [_vm._v("Budapest EMB)")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions du "), _c('b', [_vm._v("Zephyr [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Brussels, Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni Suvini "), _c('b', [_vm._v("Zerboni [2, 6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Galleria del Corso, 4"), _c('br'), _vm._v("20122 Milano, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 2-770701")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 2-77070261"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.esz.it",
      "target": "_blank"
    }
  }, [_vm._v("www.esz.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Wilhelm "), _c('b', [_vm._v("Zimmermann")]), _vm._v(" Musikverlag "), _c('b', [_vm._v("[6, 14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 69-978286-6")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 69-978286-79"), _c('br'), _vm._v("Frankfurt, Germany"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.zimmermann-frankfurt.de",
      "target": "_blank"
    }
  }, [_vm._v("www.zimmermann-frankfurt.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions Aug. "), _c('b', [_vm._v("Zurfluh [6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("13, Avenue du Lycée Lakanal"), _c('br'), _vm._v("92340 Bourg-la-Reine, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-46-60-50-28")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-46-61-52-30"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editions-aug-zurfluh.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.editions-aug-zurfluh.fr")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ab570ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/address.vue
// module id = 81
// module chunks = 0